
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Button,
//   IconButton,
//   Chip,
//   Tooltip,
//   CircularProgress,
//   Avatar,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   DialogContentText,
//   TextField,
//   InputAdornment,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Select,
//   Grid,
//   Switch,
//   FormControlLabel,
//   Pagination,
//   Divider,
//   Checkbox,
//   OutlinedInput,
//   FormHelperText,
//   ListItemText,
//   Drawer,
//   useTheme,
//   useMediaQuery,
//   Radio,
//   RadioGroup,
//   Alert,
// } from '@mui/material';
// import {
//   Add,
//   Delete,
//   Refresh,
//   Send,
//   Block,
//   CheckCircle,
//   Search,
//   Edit,
//   Close,
//   Save,
//   Person,
//   Email,
//   Work,
//   Phone,
//   ArrowBack,
//   LocationOn,
//   Business,
// } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';
// import { useSnackbar } from 'notistack';
// import { useTheme as useCustomTheme } from '../../context/ThemeContext';
// import { useAuth } from '../../context/AuthContext';
// import { AccessDeniedModal } from '../../components/AccessDeniedModal';
// import userApi, { User, UpdateUserData, CreateUserData } from '../../services/userApi';

// const ROLES = [
//   { value: 'admin', label: 'Admin', description: 'Full system access including user management' },
//   { value: 'risk_manager', label: 'Risk Manager', description: 'Can manage risk assessments and vendor relationships' },
//   { value: 'risk_analyst', label: 'Risk Analyst', description: 'Can view vendor risk data, run scans, analyze indicators, and generate reports' },
//   { value: 'reviewer', label: 'Reviewer', description: 'Can review and approve risk assessments' },
//   { value: 'viewer', label: 'Viewer', description: 'Read-only access to vendor risk data' },
// ];

// const DEPARTMENTS = [
//   'IT', 'Security', 'Compliance', 'Risk Management', 'Finance', 'Legal', 'Operations', 'HR', 'Marketing', 'Sales'
// ];

// const LOCATIONS = [
//   'North America', 'EMEA', 'APAC', 'LATAM', 'Global'
// ];

// export default function Users() {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const { enqueueSnackbar } = useSnackbar();
//   const navigate = useNavigate();
//   const { user: currentUser } = useAuth();
  
//   // ─── Theme Colors ──────────────────────────────────────────────────────────
//   const { mode } = useCustomTheme();
//   const isDark = mode === 'dark';

//   const themeColors = {
//     text: isDark ? '#e2e8f0' : '#0f172a',
//     muted: isDark ? '#94a3b8' : '#64748b',
//     background: isDark ? '#000000' : '#f8fafc',
//     cardBg: isDark ? '#0d0d0d' : '#ffffff',
//     border: isDark ? '#1f1f1f' : '#e2e8f0',
//     hover: isDark ? '#141414' : '#f8fafc',
//     paper: isDark ? '#0d0d0d' : '#ffffff',
//     inputBg: isDark ? '#0d0d0d' : '#ffffff',
//     chipBg: isDark ? '#1a1a1a' : '#f1f5f9',
//     drawerBg: isDark ? '#0d0d0d' : '#ffffff',
//   };
  
//   const [users, setUsers] = useState<User[]>([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState('');
//   const [roleFilter, setRoleFilter] = useState('all');
//   const [page, setPage] = useState(1);
//   const rowsPerPage = 8;
  
//   // ─── Access Denied State ──────────────────────────────────────────────────
//   const [accessDenied, setAccessDenied] = useState(false);
  
//   // Drawer state
//   const [drawerOpen, setDrawerOpen] = useState(false);
  
//   // Add User Form State
//   const [submitting, setSubmitting] = useState(false);
//   const [newUser, setNewUser] = useState({
//     name: '',
//     email: '',
//     role: 'risk_analyst',
//     sendInvitation: true,
//     jobTitle: '',
//     phoneNumber: '',
//     department: '',
//     location: '',
//   });
//   const [formErrors, setFormErrors] = useState<{ name?: string; email?: string }>({});
  
//   // Edit Dialog
//   const [editDialogOpen, setEditDialogOpen] = useState(false);
//   const [editingUser, setEditingUser] = useState<User | null>(null);
//   const [editFormData, setEditFormData] = useState<UpdateUserData>({});
//   const [editSaving, setEditSaving] = useState(false);
  
//   // Deactivate Dialog
//   const [deactivateDialogOpen, setDeactivateDialogOpen] = useState(false);
//   const [userToDeactivate, setUserToDeactivate] = useState<User | null>(null);

//   // Delete Dialog State
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [userToDelete, setUserToDelete] = useState<User | null>(null);
//   const [deleting, setDeleting] = useState(false);

//   // ─── USER LIMIT STATE ──────────────────────────────────────────────────────
//   const [userLimitReached, setUserLimitReached] = useState(false);
//   const [maxUsers, setMaxUsers] = useState(3);

//   // ─── Check Admin Access ──────────────────────────────────────────────────
//   useEffect(() => {
//     if (currentUser && currentUser.role !== 'admin' && currentUser.role !== 'super_admin') {
//       setAccessDenied(true);
//     }
//   }, [currentUser]);

//   useEffect(() => {
//     if (!accessDenied) {
//       fetchUsers();
//     }
//   }, [accessDenied]);

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       const response = await userApi.getUsers(true);
//       console.log('✅ Users fetched:', response.data.length);
//       setUsers(response.data);
      
//       // ─── CHECK USER LIMIT ──────────────────────────────────────────────
//       // Check if users count is at or above limit (3 for free tier)
//       if (response.data.length >= 3) {
//         setUserLimitReached(true);
//       } else {
//         setUserLimitReached(false);
//       }
//     } catch (error) {
//       console.error('❌ Fetch users error:', error);
//       enqueueSnackbar('Failed to load users', { variant: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddUser = async () => {
//     // Validate
//     const errors: { name?: string; email?: string } = {};
//     if (!newUser.name.trim()) errors.name = 'Full name is required';
//     if (!newUser.email.trim()) errors.email = 'Email address is required';
//     else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(newUser.email)) errors.email = 'Enter a valid email address';
    
//     if (Object.keys(errors).length > 0) {
//       setFormErrors(errors);
//       return;
//     }
    
//     setSubmitting(true);
//     try {
//       const userData: CreateUserData = {
//         name: newUser.name,
//         email: newUser.email,
//         role: newUser.role,
//         job_title: newUser.jobTitle,
//         phone_number: newUser.phoneNumber,
//         send_invite: newUser.sendInvitation,
//         department: newUser.department,
//         location: newUser.location,
//         max_active_sessions: 3,
//         session_timeout_hours: 8,
//         receive_notifications: true,
//         api_access: newUser.role === 'admin',
//       };
      
//       await userApi.createUser(userData);
//       enqueueSnackbar('User created successfully!', { variant: 'success' });
      
//       // Reset form and close drawer
//       setNewUser({
//         name: '',
//         email: '',
//         role: 'risk_analyst',
//         sendInvitation: true,
//         jobTitle: '',
//         phoneNumber: '',
//         department: '',
//         location: '',
//       });
//       setFormErrors({});
//       setDrawerOpen(false);
//       fetchUsers();
//     } catch (error: any) {
//       console.error('Create error:', error.response?.data);
      
//       const errorMsg = error.response?.data?.detail || 'Failed to create user';
      
//       // ─── HANDLE USER LIMIT ERROR ──────────────────────────────────────
//       if (errorMsg.includes('User limit reached') || errorMsg.includes('limit reached')) {
//         enqueueSnackbar(errorMsg, { 
//           variant: 'warning',
//           autoHideDuration: 8000,
//           action: (
//             <Button 
//               color="inherit" 
//               size="small" 
//               onClick={() => navigate('/settings')}
//             >
//               Upgrade Plan
//             </Button>
//           )
//         });
//         setUserLimitReached(true);
//       } else {
//         enqueueSnackbar(errorMsg, { variant: 'error' });
//       }
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleEditClick = (user: User) => {
//     setEditingUser(user);
//     setEditFormData({
//       name: user.name,
//       role: user.role,
//       job_title: user.job_title || '',
//       department: user.department || '',
//       phone_number: user.phone_number || '',
//       location: user.location || '',
//       max_active_sessions: user.max_active_sessions,
//       session_timeout_hours: user.session_timeout_hours,
//       receive_notifications: user.receive_notifications,
//       api_access: user.api_access,
//     });
//     setEditDialogOpen(true);
//   };

//   const handleEditSave = async () => {
//     if (!editingUser) return;
//     setEditSaving(true);
//     try {
//       const updateData: UpdateUserData = {};
      
//       if (editFormData.name !== undefined && editFormData.name !== editingUser.name) {
//         updateData.name = editFormData.name;
//       }
//       if (editFormData.role !== undefined && editFormData.role !== editingUser.role) {
//         updateData.role = editFormData.role;
//       }
//       if (editFormData.job_title !== undefined && editFormData.job_title !== editingUser.job_title) {
//         updateData.job_title = editFormData.job_title;
//       }
//       if (editFormData.department !== undefined && editFormData.department !== editingUser.department) {
//         updateData.department = editFormData.department;
//       }
//       if (editFormData.phone_number !== undefined && editFormData.phone_number !== editingUser.phone_number) {
//         updateData.phone_number = editFormData.phone_number;
//       }
//       if (editFormData.location !== undefined && editFormData.location !== editingUser.location) {
//         updateData.location = editFormData.location;
//       }
//       if (editFormData.max_active_sessions !== undefined && editFormData.max_active_sessions !== editingUser.max_active_sessions) {
//         updateData.max_active_sessions = editFormData.max_active_sessions;
//       }
//       if (editFormData.session_timeout_hours !== undefined && editFormData.session_timeout_hours !== editingUser.session_timeout_hours) {
//         updateData.session_timeout_hours = editFormData.session_timeout_hours;
//       }
//       if (editFormData.receive_notifications !== undefined && editFormData.receive_notifications !== editingUser.receive_notifications) {
//         updateData.receive_notifications = editFormData.receive_notifications;
//       }
//       if (editFormData.api_access !== undefined && editFormData.api_access !== editingUser.api_access) {
//         updateData.api_access = editFormData.api_access;
//       }
      
//       if (Object.keys(updateData).length === 0) {
//         setEditDialogOpen(false);
//         enqueueSnackbar('No changes to update', { variant: 'info' });
//         setEditSaving(false);
//         return;
//       }
      
//       await userApi.updateUser(editingUser.id, updateData);
//       enqueueSnackbar('User updated successfully', { variant: 'success' });
//       setEditDialogOpen(false);
//       fetchUsers();
//     } catch (error: any) {
//       console.error('Update error:', error.response?.data);
//       enqueueSnackbar(error.response?.data?.detail || 'Failed to update user', { variant: 'error' });
//     } finally {
//       setEditSaving(false);
//     }
//   };

//   const handleDeactivate = async () => {
//     if (!userToDeactivate) return;
//     try {
//       await userApi.deactivateUser(userToDeactivate.id);
//       enqueueSnackbar('User deactivated successfully', { variant: 'success' });
//       fetchUsers();
//       setDeactivateDialogOpen(false);
//       setUserToDeactivate(null);
//     } catch (error) {
//       console.error('Deactivate error:', error);
//       enqueueSnackbar('Failed to deactivate user', { variant: 'error' });
//     }
//   };

//   // Delete Handlers
//   const handleDeleteClick = (user: User) => {
//     setUserToDelete(user);
//     setDeleteDialogOpen(true);
//   };

//   const handleDeleteConfirm = async () => {
//     if (!userToDelete) return;
    
//     setDeleting(true);
//     try {
//       await userApi.deleteUserPermanently(userToDelete.id);
//       enqueueSnackbar(`User "${userToDelete.name}" has been permanently deleted`, { variant: 'success' });
//       setDeleteDialogOpen(false);
//       setUserToDelete(null);
//       fetchUsers();
//     } catch (error: any) {
//       const errorMsg = error.response?.data?.detail || 'Failed to delete user';
//       enqueueSnackbar(errorMsg, { variant: 'error' });
//     } finally {
//       setDeleting(false);
//     }
//   };

//   const handleActivate = async (user: User) => {
//     try {
//       await userApi.activateUser(user.id);
//       enqueueSnackbar('User activated successfully', { variant: 'success' });
//       fetchUsers();
//     } catch (error) {
//       console.error('Activate error:', error);
//       enqueueSnackbar('Failed to activate user', { variant: 'error' });
//     }
//   };

//   const handleResendInvite = async (user: User) => {
//     try {
//       await userApi.resendInvite(user.id);
//       enqueueSnackbar('Invitation resent successfully', { variant: 'success' });
//     } catch (error) {
//       console.error('Resend invite error:', error);
//       enqueueSnackbar('Failed to resend invitation', { variant: 'error' });
//     }
//   };

//   const getRoleLabel = (role: string) => {
//     const roleMap: Record<string, string> = {
//       admin: 'Admin',
//       risk_manager: 'Risk Manager',
//       risk_analyst: 'Risk Analyst',
//       reviewer: 'Reviewer',
//       compliance_officer: 'Compliance Officer',
//       viewer: 'Viewer',
//     };
//     return roleMap[role] || 'Viewer';
//   };

//   const getStatusChip = (user: User) => {
//     if (!user.is_active) {
//       return (
//         <Chip 
//           label="Deactivated" 
//           size="small" 
//           sx={{ 
//             bgcolor: isDark ? '#1a0a0a' : '#fef2f2', 
//             color: '#dc2626', 
//             fontWeight: 600, 
//             fontSize: 11,
//             border: `1px solid ${isDark ? '#dc262640' : 'transparent'}`,
//             '& .MuiChip-label': { color: '#dc2626' }
//           }} 
//         />
//       );
//     }
//     if (user.require_password_reset) {
//       return (
//         <Chip 
//           label="Pending Invite" 
//           size="small" 
//           sx={{ 
//             bgcolor: isDark ? '#1a1400' : '#fffbeb', 
//             color: '#d97706', 
//             fontWeight: 600, 
//             fontSize: 11,
//             border: `1px solid ${isDark ? '#d9770640' : 'transparent'}`,
//             '& .MuiChip-label': { color: '#d97706' }
//           }} 
//         />
//       );
//     }
//     return (
//       <Chip 
//         label="Active" 
//         size="small" 
//         sx={{ 
//           bgcolor: isDark ? '#0a1a0a' : '#f0fdf4', 
//           color: '#0e9f6e', 
//           fontWeight: 600, 
//           fontSize: 11,
//           border: `1px solid ${isDark ? '#0e9f6e40' : 'transparent'}`,
//           '& .MuiChip-label': { color: '#0e9f6e' }
//         }} 
//       />
//     );
//   };

//   // Filter users
//   const filteredUsers = users.filter(user => {
//     const matchesSearch = user.name.toLowerCase().includes(search.toLowerCase()) ||
//                           user.email.toLowerCase().includes(search.toLowerCase()) ||
//                           getRoleLabel(user.role).toLowerCase().includes(search.toLowerCase());
//     const matchesRole = roleFilter === 'all' || user.role === roleFilter;
//     return matchesSearch && matchesRole;
//   });

//   // Pagination
//   const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
//   const paginatedUsers = filteredUsers.slice((page - 1) * rowsPerPage, page * rowsPerPage);

//   // Summary stats
//   const totalUsers = users.length;
//   const activeUsers = users.filter(u => u.is_active && !u.require_password_reset).length;
//   const pendingInvites = users.filter(u => u.require_password_reset && u.is_active).length;
//   const deactivatedUsers = users.filter(u => !u.is_active).length;

//   const getAvatarInitials = (name: string) => {
//     return name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase();
//   };

//   const getAvatarColor = (name: string) => {
//     const colors = ['#1a56db', '#0e9f6e', '#d97706', '#dc2626', '#8b5cf6', '#ec4898', '#06b6d4', '#f97316'];
//     const index = name.length % colors.length;
//     return colors[index];
//   };

//   // ─── Shared Input Styles ─────────────────────────────────────────────────
//   const inputSx = {
//     '& .MuiOutlinedInput-root': {
//       color: themeColors.text,
//       bgcolor: themeColors.inputBg,
//       '& fieldset': { borderColor: themeColors.border },
//       '&:hover fieldset': { borderColor: isDark ? '#333333' : themeColors.muted },
//       '&.Mui-focused fieldset': { borderColor: '#3b82f6' },
//       '& input::placeholder': { color: isDark ? '#6b7280' : '#94a3b8', opacity: 1 },
//     },
//     '& .MuiInputLabel-root': { color: themeColors.muted },
//     '& .MuiInputLabel-root.Mui-focused': { color: '#3b82f6' },
//     '& .MuiInputAdornment-root .MuiSvgIcon-root': { color: themeColors.muted },
//     '& .MuiFormHelperText-root': { color: themeColors.muted },
//   };

//   const selectSx = {
//     color: themeColors.text,
//     bgcolor: themeColors.inputBg,
//     '& .MuiOutlinedInput-notchedOutline': { borderColor: themeColors.border },
//     '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: isDark ? '#333333' : themeColors.muted },
//     '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#3b82f6' },
//     '& .MuiSelect-icon': { color: themeColors.muted },
//   };

//   const menuPaperSx = {
//     bgcolor: themeColors.paper,
//     border: `1px solid ${themeColors.border}`,
//     boxShadow: isDark ? '0 4px 20px rgba(0,0,0,0.8)' : '0 4px 16px rgba(0,0,0,0.1)',
//     '& .MuiMenuItem-root': { color: themeColors.text },
//     '& .MuiMenuItem-root:hover': { bgcolor: themeColors.hover },
//   };

//   // ─── Access Denied Handler ──────────────────────────────────────────────
//   const handleAccessDeniedClose = () => {
//     setAccessDenied(false);
//     navigate('/dashboard');
//   };

//   // ─── Loading State ──────────────────────────────────────────────────────
//   if (loading) {
//     return (
//       <Box sx={{ 
//         display: 'flex', 
//         justifyContent: 'center', 
//         alignItems: 'center', 
//         height: '50vh',
//         bgcolor: themeColors.background,
//       }}>
//         <CircularProgress />
//       </Box>
//     );
//   }

//   // ─── Access Denied Modal ──────────────────────────────────────────────
//   if (accessDenied) {
//     return (
//       <AccessDeniedModal
//         open={true}
//         onClose={handleAccessDeniedClose}
//         pageName="Teams (User Management)"
//       />
//     );
//   }

//   return (
//     <Box sx={{ 
//       bgcolor: themeColors.background, 
//       minHeight: '100vh', 
//       p: 3 
//     }}>
//       {/* Header */}
//       <Box sx={{ mb: 4 }}>
//         <Typography variant="h4" sx={{ fontWeight: 700, color: themeColors.text, mb: 1 }}>
//           Users
//         </Typography>
//         <Typography variant="body2" sx={{ color: themeColors.muted }}>
//           Manage users, their roles, and access to the TPRM platform.
//         </Typography>
//       </Box>

//       {/* ─── USER LIMIT WARNING BANNER ─────────────────────────────────────── */}
//       {userLimitReached && (
//         <Alert 
//           severity="warning" 
//           sx={{ mb: 3, borderRadius: 2 }}
//           action={
//             <Button 
//               color="inherit" 
//               size="small" 
//               onClick={() => navigate('/settings')}
//               sx={{ fontWeight: 600 }}
//             >
//               Upgrade Plan
//             </Button>
//           }
//         >
//           <Typography variant="body2">
//             <strong>⚠️ User limit reached.</strong> Your plan allows only {maxUsers} users. 
//             Please upgrade to add more team members.
//           </Typography>
//         </Alert>
//       )}

//       {/* Summary Cards */}
//       <Grid container spacing={3} sx={{ mb: 4 }}>
//         <Grid size={{ xs: 12, sm: 6, md: 3 }}>
//           <Paper sx={{ 
//             p: 2.5, 
//             textAlign: 'center', 
//             borderRadius: 2,
//             bgcolor: themeColors.cardBg,
//             border: `1px solid ${themeColors.border}`,
//           }}>
//             <Typography variant="h3" sx={{ fontWeight: 700, color: themeColors.text }}>
//               {totalUsers}
//             </Typography>
//             <Typography variant="body2" sx={{ fontWeight: 600, color: themeColors.muted }}>
//               Total Users
//             </Typography>
//             <Typography variant="caption" sx={{ color: themeColors.muted }}>
//               All users in the organization
//             </Typography>
//           </Paper>
//         </Grid>
//         <Grid size={{ xs: 12, sm: 6, md: 3 }}>
//           <Paper sx={{ 
//             p: 2.5, 
//             textAlign: 'center', 
//             borderRadius: 2,
//             bgcolor: themeColors.cardBg,
//             border: `1px solid ${themeColors.border}`,
//           }}>
//             <Typography variant="h3" sx={{ fontWeight: 700, color: '#0e9f6e' }}>
//               {activeUsers}
//             </Typography>
//             <Typography variant="body2" sx={{ fontWeight: 600, color: themeColors.muted }}>
//               Active Users
//             </Typography>
//             <Typography variant="caption" sx={{ color: themeColors.muted }}>
//               Enabled accounts
//             </Typography>
//           </Paper>
//         </Grid>
//         <Grid size={{ xs: 12, sm: 6, md: 3 }}>
//           <Paper sx={{ 
//             p: 2.5, 
//             textAlign: 'center', 
//             borderRadius: 2,
//             bgcolor: themeColors.cardBg,
//             border: `1px solid ${themeColors.border}`,
//           }}>
//             <Typography variant="h3" sx={{ fontWeight: 700, color: '#d97706' }}>
//               {pendingInvites}
//             </Typography>
//             <Typography variant="body2" sx={{ fontWeight: 600, color: themeColors.muted }}>
//               Pending Invites
//             </Typography>
//             <Typography variant="caption" sx={{ color: themeColors.muted }}>
//               Invitations sent
//             </Typography>
//           </Paper>
//         </Grid>
//         <Grid size={{ xs: 12, sm: 6, md: 3 }}>
//           <Paper sx={{ 
//             p: 2.5, 
//             textAlign: 'center', 
//             borderRadius: 2,
//             bgcolor: themeColors.cardBg,
//             border: `1px solid ${themeColors.border}`,
//           }}>
//             <Typography variant="h3" sx={{ fontWeight: 700, color: '#dc2626' }}>
//               {deactivatedUsers}
//             </Typography>
//             <Typography variant="body2" sx={{ fontWeight: 600, color: themeColors.muted }}>
//               Deactivated Users
//             </Typography>
//             <Typography variant="caption" sx={{ color: themeColors.muted }}>
//               Inactive accounts
//             </Typography>
//           </Paper>
//         </Grid>
//       </Grid>

//       {/* Search and Filter Bar */}
//       <Paper sx={{ 
//         p: 2, 
//         mb: 3, 
//         display: 'flex', 
//         justifyContent: 'space-between', 
//         alignItems: 'center', 
//         flexWrap: 'wrap', 
//         gap: 2,
//         bgcolor: themeColors.cardBg,
//         border: `1px solid ${themeColors.border}`,
//       }}>
//         <Box sx={{ display: 'flex', gap: 2, flex: 1, maxWidth: 400 }}>
//           <TextField
//             size="small"
//             placeholder="Search users by name, email, or role..."
//             value={search}
//             onChange={(e) => setSearch(e.target.value)}
//             fullWidth
//             sx={inputSx}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Search sx={{ fontSize: 18, color: themeColors.muted }} />
//                 </InputAdornment>
//               ),
//             }}
//           />
//           <FormControl size="small" sx={{ minWidth: 150 }}>
//             <InputLabel sx={{ color: themeColors.muted }}>Role</InputLabel>
//             <Select
//               value={roleFilter}
//               onChange={(e) => setRoleFilter(e.target.value)}
//               label="Role"
//               sx={selectSx}
//               MenuProps={{ PaperProps: { sx: menuPaperSx } }}
//             >
//               <MenuItem value="all" sx={{ color: themeColors.text }}>All Roles</MenuItem>
//               <MenuItem value="admin" sx={{ color: themeColors.text }}>Admin</MenuItem>
//               <MenuItem value="risk_manager" sx={{ color: themeColors.text }}>Risk Manager</MenuItem>
//               <MenuItem value="risk_analyst" sx={{ color: themeColors.text }}>Risk Analyst</MenuItem>
//               <MenuItem value="reviewer" sx={{ color: themeColors.text }}>Reviewer</MenuItem>
//               <MenuItem value="viewer" sx={{ color: themeColors.text }}>Viewer</MenuItem>
//             </Select>
//           </FormControl>
//         </Box>
//         <Button
//           variant="contained"
//           startIcon={<Add />}
//           onClick={() => setDrawerOpen(true)}
//           sx={{ 
//             textTransform: 'none', 
//             px: 3,
//             bgcolor: '#3b82f6',
//             '&:hover': { bgcolor: '#2563eb' },
//           }}
//         >
//           Add User
//         </Button>
//       </Paper>

//       {/* Users Table */}
//       <TableContainer component={Paper} sx={{ 
//         borderRadius: 2, 
//         overflow: 'hidden',
//         bgcolor: themeColors.cardBg,
//         border: `1px solid ${themeColors.border}`,
//       }}>
//         <Table>
//           <TableHead sx={{ bgcolor: isDark ? '#0d0d0d' : '#f8fafc' }}>
//             <TableRow>
//               {['Name', 'Email', 'Role', 'Status', 'Last Login', 'Actions'].map((h) => (
//                 <TableCell 
//                   key={h} 
//                   sx={{ 
//                     fontWeight: 600, 
//                     color: themeColors.muted, 
//                     fontSize: 12,
//                     borderBottom: `1px solid ${themeColors.border}`,
//                   }}
//                 >
//                   {h}
//                 </TableCell>
//               ))}
//             </TableRow>
//           </TableHead>
//           <TableBody>
//             {paginatedUsers.length === 0 ? (
//               <TableRow>
//                 <TableCell colSpan={6} align="center" sx={{ py: 6, color: themeColors.muted }}>
//                   <Typography color="text.secondary" sx={{ color: themeColors.muted }}>No users found</Typography>
//                 </TableCell>
//               </TableRow>
//             ) : (
//               paginatedUsers.map((u) => (
//                 <TableRow key={u.id} hover sx={{ 
//                   '&:hover td': { bgcolor: themeColors.hover },
//                   '& td': { borderBottom: `1px solid ${themeColors.border}` },
//                 }}>
//                   <TableCell>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//                       <Avatar
//                         sx={{
//                           bgcolor: getAvatarColor(u.name),
//                           width: 36,
//                           height: 36,
//                           fontSize: 14,
//                           fontWeight: 600,
//                         }}
//                       >
//                         {getAvatarInitials(u.name)}
//                       </Avatar>
//                       <Typography variant="body2" fontWeight={600} sx={{ color: themeColors.text }}>
//                         {u.name}
//                       </Typography>
//                     </Box>
//                   </TableCell>
//                   <TableCell>
//                     <Typography variant="body2" sx={{ color: themeColors.muted }}>
//                       {u.email}
//                     </Typography>
//                   </TableCell>
//                   <TableCell>
//                     <Chip
//                       label={getRoleLabel(u.role)}
//                       size="small"
//                       sx={{ 
//                         fontWeight: 600, 
//                         fontSize: 11, 
//                         bgcolor: isDark ? '#0a1628' : '#e0e7ff', 
//                         color: '#1a56db',
//                         border: `1px solid ${isDark ? '#1a56db40' : 'transparent'}`,
//                         '& .MuiChip-label': { color: '#1a56db' }
//                       }}
//                     />
//                   </TableCell>
//                   <TableCell>
//                     {getStatusChip(u)}
//                   </TableCell>
//                   <TableCell>
//                     <Typography variant="body2" sx={{ color: themeColors.muted }} fontSize={12}>
//                       {u.last_login_at ? new Date(u.last_login_at).toLocaleString() : '—'}
//                     </Typography>
//                   </TableCell>
//                   <TableCell>
//                     <Box sx={{ display: 'flex', gap: 1 }}>
//                       <Tooltip title="Edit User">
//                         <IconButton
//                           size="small"
//                           onClick={() => handleEditClick(u)}
//                           sx={{ color: '#1a56db' }}
//                         >
//                           <Edit fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
                      
//                       {/* ─── DELETE BUTTON ─────────────────────────── */}
//                       <Tooltip title="Delete User">
//                         <IconButton
//                           size="small"
//                           onClick={() => handleDeleteClick(u)}
//                           sx={{ color: '#dc2626' }}
//                           disabled={u.id === currentUser?.id}
//                         >
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </Tooltip>
                      
//                       {u.is_active ? (
//                         <Tooltip title="Deactivate User">
//                           <IconButton
//                             size="small"
//                             onClick={() => {
//                               setUserToDeactivate(u);
//                               setDeactivateDialogOpen(true);
//                             }}
//                             sx={{ color: '#dc2626' }}
//                           >
//                             <Block fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       ) : (
//                         <Tooltip title="Activate User">
//                           <IconButton
//                             size="small"
//                             onClick={() => handleActivate(u)}
//                             sx={{ color: '#0e9f6e' }}
//                           >
//                             <CheckCircle fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       )}
//                       {u.require_password_reset && u.is_active && (
//                         <Tooltip title="Resend Invite">
//                           <IconButton
//                             size="small"
//                             onClick={() => handleResendInvite(u)}
//                             sx={{ color: '#0e9f6e' }}
//                           >
//                             <Send fontSize="small" />
//                           </IconButton>
//                         </Tooltip>
//                       )}
//                     </Box>
//                   </TableCell>
//                 </TableRow>
//               ))
//             )}
//           </TableBody>
//         </Table>
//       </TableContainer>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3 }}>
//           <Typography variant="caption" sx={{ color: themeColors.muted }}>
//             Showing {(page - 1) * rowsPerPage + 1} to {Math.min(page * rowsPerPage, filteredUsers.length)} of {filteredUsers.length} users
//           </Typography>
//           <Pagination
//             count={totalPages}
//             page={page}
//             onChange={(_, value) => setPage(value)}
//             shape="rounded"
//             size="small"
//             sx={{
//               '& .MuiPaginationItem-root': {
//                 color: themeColors.muted,
//                 '&.Mui-selected': { bgcolor: '#3b82f6', color: '#fff' },
//               },
//             }}
//           />
//         </Box>
//       )}

//       {/* Slide-in Drawer for Add User */}
//       <Drawer
//         anchor="right"
//         open={drawerOpen}
//         onClose={() => setDrawerOpen(false)}
//         PaperProps={{
//           sx: {
//             width: isMobile ? '100%' : 550,
//             bgcolor: themeColors.drawerBg,
//             borderRadius: isMobile ? 0 : '16px 0 0 16px',
//             border: `1px solid ${themeColors.border}`,
//             p: 0,
//           }
//         }}
//       >
//         {/* Drawer Header */}
//         <Box sx={{ 
//           display: 'flex', 
//           alignItems: 'center', 
//           justifyContent: 'space-between',
//           p: 2.5,
//           borderBottom: `1px solid ${themeColors.border}`,
//           bgcolor: themeColors.drawerBg,
//         }}>
//           <Typography variant="h6" sx={{ fontWeight: 700, color: themeColors.text }}>
//             Add New User
//           </Typography>
//           <IconButton onClick={() => setDrawerOpen(false)} size="small" sx={{ color: themeColors.muted }}>
//             <Close />
//           </IconButton>
//         </Box>

//         {/* Drawer Content */}
//         <Box sx={{ p: 3, overflowY: 'auto', flex: 1 }}>
//           <Typography variant="body2" sx={{ color: themeColors.muted, mb: 3 }}>
//             Create a new user and define their role, permissions and data access.
//           </Typography>

//           {/* Full Name */}
//           <TextField
//             fullWidth
//             label="Full Name"
//             placeholder="Enter full name"
//             value={newUser.name}
//             onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
//             error={!!formErrors.name}
//             helperText={formErrors.name}
//             required
//             sx={{ mb: 3, ...inputSx }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Person sx={{ color: themeColors.muted }} />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* Work Email */}
//           <TextField
//             fullWidth
//             label="Work Email"
//             type="email"
//             placeholder="Enter work email address"
//             value={newUser.email}
//             onChange={(e) => setNewUser({ ...newUser, email: e.target.value })}
//             error={!!formErrors.email}
//             helperText={formErrors.email}
//             required
//             sx={{ mb: 3, ...inputSx }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Email sx={{ color: themeColors.muted }} />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* Job Title */}
//           <TextField
//             fullWidth
//             label="Job Title"
//             placeholder="Enter job title"
//             value={newUser.jobTitle}
//             onChange={(e) => setNewUser({ ...newUser, jobTitle: e.target.value })}
//             sx={{ mb: 3, ...inputSx }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Work sx={{ color: themeColors.muted }} />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* Department */}
//           <FormControl fullWidth sx={{ mb: 3 }}>
//             <InputLabel sx={{ color: themeColors.muted }}>Department</InputLabel>
//             <Select
//               value={newUser.department}
//               onChange={(e) => setNewUser({ ...newUser, department: e.target.value })}
//               label="Department"
//               sx={selectSx}
//               MenuProps={{ PaperProps: { sx: menuPaperSx } }}
//             >
//               <MenuItem value="" sx={{ color: themeColors.text }}>Select department</MenuItem>
//               {DEPARTMENTS.map(dept => (
//                 <MenuItem key={dept} value={dept} sx={{ color: themeColors.text }}>{dept}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           {/* Phone Number */}
//           <TextField
//             fullWidth
//             label="Phone Number (Optional)"
//             placeholder="+1 Enter phone number"
//             value={newUser.phoneNumber}
//             onChange={(e) => setNewUser({ ...newUser, phoneNumber: e.target.value })}
//             sx={{ mb: 3, ...inputSx }}
//             InputProps={{
//               startAdornment: (
//                 <InputAdornment position="start">
//                   <Phone sx={{ color: themeColors.muted }} />
//                 </InputAdornment>
//               ),
//             }}
//           />

//           {/* Location */}
//           <FormControl fullWidth sx={{ mb: 3 }}>
//             <InputLabel sx={{ color: themeColors.muted }}>Location (Optional)</InputLabel>
//             <Select
//               value={newUser.location}
//               onChange={(e) => setNewUser({ ...newUser, location: e.target.value })}
//               label="Location (Optional)"
//               sx={selectSx}
//               MenuProps={{ PaperProps: { sx: menuPaperSx } }}
//             >
//               <MenuItem value="" sx={{ color: themeColors.text }}>Select location</MenuItem>
//               {LOCATIONS.map(loc => (
//                 <MenuItem key={loc} value={loc} sx={{ color: themeColors.text }}>{loc}</MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <Divider sx={{ my: 3, borderColor: themeColors.border }} />

//           {/* Account Settings */}
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: themeColors.text }}>
//             Account Settings
//           </Typography>
          
//           <FormControlLabel
//             control={
//               <Switch
//                 checked={newUser.sendInvitation}
//                 onChange={(e) => setNewUser({ ...newUser, sendInvitation: e.target.checked })}
//                 sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#3b82f6' } }}
//               />
//             }
//             label={<Typography sx={{ color: themeColors.text }}>Send invite email</Typography>}
//             sx={{ mb: 1 }}
//           />
//           <Typography variant="caption" sx={{ color: themeColors.muted, display: 'block', mb: 3, ml: 4 }}>
//             User will receive an email invitation to join
//           </Typography>

//           <FormControlLabel
//             control={<Switch checked={true} disabled />}
//             label={<Typography sx={{ color: themeColors.text }}>Require password reset on first login</Typography>}
//             sx={{ mb: 1 }}
//           />
//           <Typography variant="caption" sx={{ color: themeColors.muted, display: 'block', mb: 3, ml: 4 }}>
//             User must set a new password on first login
//           </Typography>

//           <Divider sx={{ my: 3, borderColor: themeColors.border }} />

//           {/* Role & Permissions */}
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: themeColors.text }}>
//             Role & Permissions
//           </Typography>
          
//           <FormControl fullWidth sx={{ mb: 3 }}>
//             <InputLabel sx={{ color: themeColors.muted }}>Assign Role</InputLabel>
//             <Select
//               value={newUser.role}
//               onChange={(e) => setNewUser({ ...newUser, role: e.target.value })}
//               label="Assign Role"
//               sx={selectSx}
//               MenuProps={{ PaperProps: { sx: menuPaperSx } }}
//             >
//               {ROLES.map(role => (
//                 <MenuItem key={role.value} value={role.value} sx={{ color: themeColors.text }}>
//                   <Box>
//                     <Typography variant="body2" fontWeight={500} sx={{ color: themeColors.text }}>
//                       {role.label}
//                     </Typography>
//                     <Typography variant="caption" sx={{ color: themeColors.muted }}>
//                       {role.description}
//                     </Typography>
//                   </Box>
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>

//           <Divider sx={{ my: 3, borderColor: themeColors.border }} />

//           {/* Data Operations */}
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: themeColors.text }}>
//             Data Operations
//           </Typography>
//           <Typography variant="caption" sx={{ color: themeColors.muted, mb: 2, display: 'block' }}>
//             Define what operations the user can perform in the platform.
//           </Typography>

//           <Grid container spacing={1} sx={{ mb: 3 }}>
//             <Grid size={{ xs: 6 }}>
//               <FormControlLabel 
//                 control={<Switch checked={true} disabled />} 
//                 label={<Typography sx={{ color: themeColors.text }}>View Data</Typography>} 
//               />
//             </Grid>
//             <Grid size={{ xs: 6 }}>
//               <FormControlLabel 
//                 control={<Switch checked={newUser.role !== 'viewer'} disabled={newUser.role === 'viewer'} />} 
//                 label={<Typography sx={{ color: themeColors.text }}>Edit Data</Typography>} 
//               />
//             </Grid>
//             <Grid size={{ xs: 6 }}>
//               <FormControlLabel 
//                 control={<Switch checked={newUser.role === 'admin'} disabled={newUser.role !== 'admin'} />} 
//                 label={<Typography sx={{ color: themeColors.text }}>Delete Data</Typography>} 
//               />
//             </Grid>
//             <Grid size={{ xs: 6 }}>
//               <FormControlLabel 
//                 control={<Switch checked={true} disabled />} 
//                 label={<Typography sx={{ color: themeColors.text }}>Export Data</Typography>} 
//               />
//             </Grid>
//             <Grid size={{ xs: 6 }}>
//               <FormControlLabel 
//                 control={<Switch checked={newUser.role === 'admin'} disabled={newUser.role !== 'admin'} />} 
//                 label={<Typography sx={{ color: themeColors.text }}>System Settings Access</Typography>} 
//               />
//             </Grid>
//           </Grid>

//           <Divider sx={{ my: 3, borderColor: themeColors.border }} />

//           {/* Data Access */}
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: themeColors.text }}>
//             Data Access
//           </Typography>
          
//           <FormControl component="fieldset" sx={{ mb: 3 }}>
//             <RadioGroup value="all">
//               <FormControlLabel 
//                 value="all" 
//                 control={<Radio sx={{ color: themeColors.muted, '&.Mui-checked': { color: '#3b82f6' } }} />} 
//                 label={<Typography sx={{ color: themeColors.text }}>All Data</Typography>} 
//               />
//               <FormControlLabel 
//                 value="restricted" 
//                 control={<Radio disabled />} 
//                 label={<Typography sx={{ color: themeColors.muted }}>Restricted Access</Typography>} 
//                 disabled 
//               />
//               <FormControlLabel 
//                 value="custom" 
//                 control={<Radio disabled />} 
//                 label={<Typography sx={{ color: themeColors.muted }}>Custom Scope</Typography>} 
//                 disabled 
//               />
//             </RadioGroup>
//             <Typography variant="caption" sx={{ color: themeColors.muted }}>
//               User can access all data in the platform
//             </Typography>
//           </FormControl>

//           <Divider sx={{ my: 3, borderColor: themeColors.border }} />

//           {/* Session Management */}
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: themeColors.text }}>
//             Session Management
//           </Typography>
          
//           <Grid container spacing={2} sx={{ mb: 3 }}>
//             <Grid size={{ xs: 12 }}>
//               <TextField
//                 fullWidth
//                 label="Max Active Sessions"
//                 type="number"
//                 value={3}
//                 disabled
//                 helperText="User can be logged in on a maximum of 3 devices at the same time."
//                 sx={inputSx}
//               />
//             </Grid>
//             <Grid size={{ xs: 12 }}>
//               <TextField
//                 fullWidth
//                 label="Session Timeout"
//                 type="number"
//                 value={8}
//                 disabled
//                 helperText="Automatically log out inactive sessions after the selected time."
//                 sx={inputSx}
//               />
//             </Grid>
//           </Grid>

//           <Divider sx={{ my: 3, borderColor: themeColors.border }} />

//           {/* Additional Settings */}
//           <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: themeColors.text }}>
//             Additional Settings
//           </Typography>

//           <FormControlLabel
//             control={<Switch checked={true} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#3b82f6' } }} />}
//             label={<Typography sx={{ color: themeColors.text }}>User is active</Typography>}
//             sx={{ mb: 1 }}
//           />
//           <Typography variant="caption" sx={{ color: themeColors.muted, display: 'block', mb: 2, ml: 4 }}>
//             Active users can log in and access the platform
//           </Typography>

//           <FormControlLabel
//             control={<Switch checked={true} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#3b82f6' } }} />}
//             label={<Typography sx={{ color: themeColors.text }}>Receive security notifications</Typography>}
//             sx={{ mb: 1 }}
//           />
//           <Typography variant="caption" sx={{ color: themeColors.muted, display: 'block', mb: 2, ml: 4 }}>
//             Send important security and risk alerts
//           </Typography>

//           <FormControlLabel
//             control={<Switch checked={true} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#3b82f6' } }} />}
//             label={<Typography sx={{ color: themeColors.text }}>Include in audit logs</Typography>}
//             sx={{ mb: 1 }}
//           />
//           <Typography variant="caption" sx={{ color: themeColors.muted, display: 'block', mb: 2, ml: 4 }}>
//             Track user activities in audit logs
//           </Typography>

//           <FormControlLabel
//             control={<Switch checked={newUser.role === 'admin'} sx={{ '& .MuiSwitch-switchBase.Mui-checked': { color: '#3b82f6' } }} />}
//             label={<Typography sx={{ color: themeColors.text }}>API Access</Typography>}
//             sx={{ mb: 1 }}
//           />
//           <Typography variant="caption" sx={{ color: themeColors.muted, display: 'block', mb: 3, ml: 4 }}>
//             Allow user to generate API keys and access API
//           </Typography>
//         </Box>

//         {/* Drawer Footer */}
//         <Box sx={{ 
//           p: 2.5, 
//           borderTop: `1px solid ${themeColors.border}`, 
//           display: 'flex', 
//           justifyContent: 'flex-end', 
//           gap: 2,
//           bgcolor: themeColors.drawerBg,
//         }}>
//           <Button 
//             variant="outlined" 
//             onClick={() => setDrawerOpen(false)}
//             sx={{ 
//               textTransform: 'none', 
//               px: 3,
//               borderColor: themeColors.border,
//               color: themeColors.text,
//               '&:hover': { borderColor: themeColors.muted, bgcolor: themeColors.hover },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             variant="contained" 
//             onClick={handleAddUser}
//             disabled={submitting}
//             startIcon={submitting ? <CircularProgress size={20} /> : <Save />}
//             sx={{ 
//               textTransform: 'none', 
//               px: 3,
//               bgcolor: '#3b82f6',
//               '&:hover': { bgcolor: '#2563eb' },
//               '&.Mui-disabled': { bgcolor: isDark ? '#1a1a1a' : '#e5e7eb' },
//             }}
//           >
//             {submitting ? 'Creating...' : 'Create User'}
//           </Button>
//         </Box>
//       </Drawer>

//       {/* Edit User Dialog */}
//       <Dialog 
//         open={editDialogOpen} 
//         onClose={() => setEditDialogOpen(false)} 
//         maxWidth="sm" 
//         fullWidth
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 2, 
//             bgcolor: themeColors.paper,
//             border: `1px solid ${themeColors.border}`,
//             boxShadow: isDark ? '0 8px 40px rgba(0,0,0,0.9)' : undefined,
//           } 
//         }}
//       >
//         <DialogTitle sx={{ 
//           display: 'flex', 
//           justifyContent: 'space-between', 
//           alignItems: 'center',
//           color: themeColors.text,
//           borderBottom: `1px solid ${themeColors.border}`,
//         }}>
//           <Typography variant="h6" fontWeight={600} sx={{ color: themeColors.text }}>Edit User</Typography>
//           <IconButton onClick={() => setEditDialogOpen(false)} size="small" sx={{ color: themeColors.muted }}>
//             <Close />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent dividers sx={{ borderColor: themeColors.border }}>
//           <Grid container spacing={2} sx={{ pt: 1 }}>
//             <Grid size={{ xs: 12 }}>
//               <TextField
//                 fullWidth
//                 label="Full Name"
//                 value={editFormData.name || ''}
//                 onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
//                 sx={inputSx}
//               />
//             </Grid>
//             <Grid size={{ xs: 12 }}>
//               <FormControl fullWidth>
//                 <InputLabel sx={{ color: themeColors.muted }}>Role</InputLabel>
//                 <Select
//                   value={editFormData.role || 'viewer'}
//                   onChange={(e) => setEditFormData({ ...editFormData, role: e.target.value })}
//                   label="Role"
//                   sx={selectSx}
//                   MenuProps={{ PaperProps: { sx: menuPaperSx } }}
//                 >
//                   {ROLES.map(role => (
//                     <MenuItem key={role.value} value={role.value} sx={{ color: themeColors.text }}>
//                       <Box>
//                         <Typography variant="body2" fontWeight={500} sx={{ color: themeColors.text }}>
//                           {role.label}
//                         </Typography>
//                         <Typography variant="caption" sx={{ color: themeColors.muted }}>
//                           {role.description}
//                         </Typography>
//                       </Box>
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>
//             <Grid size={{ xs: 12 }}>
//               <TextField
//                 fullWidth
//                 label="Job Title"
//                 value={editFormData.job_title || ''}
//                 onChange={(e) => setEditFormData({ ...editFormData, job_title: e.target.value })}
//                 sx={inputSx}
//               />
//             </Grid>
//             <Grid size={{ xs: 12 }}>
//               <TextField
//                 fullWidth
//                 label="Phone Number"
//                 value={editFormData.phone_number || ''}
//                 onChange={(e) => setEditFormData({ ...editFormData, phone_number: e.target.value })}
//                 sx={inputSx}
//               />
//             </Grid>
//           </Grid>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, gap: 1, borderTop: `1px solid ${themeColors.border}` }}>
//           <Button 
//             onClick={() => setEditDialogOpen(false)} 
//             variant="outlined"
//             sx={{ 
//               borderColor: themeColors.border,
//               color: themeColors.text,
//               '&:hover': { borderColor: themeColors.muted, bgcolor: themeColors.hover },
//             }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleEditSave} 
//             variant="contained" 
//             disabled={editSaving}
//             sx={{
//               bgcolor: '#3b82f6',
//               '&:hover': { bgcolor: '#2563eb' },
//               '&.Mui-disabled': { bgcolor: isDark ? '#1a1a1a' : '#e5e7eb' },
//             }}
//           >
//             {editSaving ? <CircularProgress size={20} /> : 'Save Changes'}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Deactivate Confirmation Dialog */}
//       <Dialog 
//         open={deactivateDialogOpen} 
//         onClose={() => setDeactivateDialogOpen(false)}
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 2, 
//             bgcolor: themeColors.paper,
//             border: `1px solid ${themeColors.border}`,
//             boxShadow: isDark ? '0 8px 40px rgba(0,0,0,0.9)' : undefined,
//           } 
//         }}
//       >
//         <DialogTitle sx={{ color: themeColors.text }}>Deactivate User</DialogTitle>
//         <DialogContent>
//           <DialogContentText sx={{ color: themeColors.muted }}>
//             Are you sure you want to deactivate {userToDeactivate?.name}? 
//             This user will no longer be able to access the platform.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions sx={{ p: 2 }}>
//           <Button 
//             onClick={() => setDeactivateDialogOpen(false)}
//             sx={{ color: themeColors.muted }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleDeactivate} 
//             color="error" 
//             variant="contained"
//           >
//             Deactivate
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog 
//         open={deleteDialogOpen} 
//         onClose={() => setDeleteDialogOpen(false)}
//         PaperProps={{ 
//           sx: { 
//             borderRadius: 2, 
//             bgcolor: themeColors.paper,
//             border: `1px solid ${themeColors.border}`,
//             boxShadow: isDark ? '0 8px 40px rgba(0,0,0,0.9)' : undefined,
//           } 
//         }}
//       >
//         <DialogTitle sx={{ color: themeColors.text, display: 'flex', alignItems: 'center', gap: 1 }}>
//           <Delete sx={{ color: '#dc2626' }} />
//           Permanently Delete User
//         </DialogTitle>
//         <DialogContent>
//           <Box sx={{ mb: 2 }}>
//             <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }}>
//               <Typography variant="body2" fontWeight={600}>
//                 ⚠️ This action cannot be undone!
//               </Typography>
//             </Alert>
//           </Box>
//           <DialogContentText sx={{ color: themeColors.muted }}>
//             Are you sure you want to permanently delete <strong style={{ color: themeColors.text }}>{userToDelete?.name}</strong> ({userToDelete?.email})?
//           </DialogContentText>
//           <DialogContentText sx={{ color: themeColors.muted, mt: 1, fontSize: 14 }}>
//             This will:
//           </DialogContentText>
//           <Box component="ul" sx={{ color: themeColors.muted, pl: 2, mt: 1 }}>
//             <li>Permanently remove the user from the system</li>
//             <li>Delete all their sessions and restrictions</li>
//             <li>Remove their access to the platform</li>
//           </Box>
//         </DialogContent>
//         <DialogActions sx={{ p: 2, gap: 1 }}>
//           <Button 
//             onClick={() => setDeleteDialogOpen(false)}
//             sx={{ color: themeColors.muted }}
//           >
//             Cancel
//           </Button>
//           <Button 
//             onClick={handleDeleteConfirm} 
//             color="error" 
//             variant="contained"
//             disabled={deleting}
//             startIcon={deleting ? <CircularProgress size={20} color="inherit" /> : <Delete />}
//           >
//             {deleting ? 'Deleting...' : 'Permanently Delete'}
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </Box>
//   );
// }

import React, { useEffect, useMemo, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { QueryKey, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useTheme as useCustomTheme } from '../../context/ThemeContext';
import { useAuth } from '../../context/AuthContext';
import { AccessDeniedModal } from '../../components/AccessDeniedModal';
import userApi, { api, User, UpdateUserData, CreateUserData } from '../../services/userApi';
import { T, sans, card, topBtn } from '../Vendors/VendorDetails';
import PhoneNumberInput from '../../components/PhoneNumberInput';

/* ── reference data ─────────────────────────────────────────────── */
const ROLES = [
  { value: 'admin', label: 'Admin', color: '#7C3AED', description: 'Full access, including team, settings and AI provider keys' },
  { value: 'risk_manager', label: 'Risk Manager', color: '#2563EB', description: 'Owns vendor relationships and risk decisions' },
  { value: 'risk_analyst', label: 'Risk Analyst', color: '#0D9488', description: 'Runs scans, analyses findings and builds reports' },
  { value: 'reviewer', label: 'Reviewer', color: '#D97706', description: 'Reviews assessments and questionnaire answers' },
  { value: 'viewer', label: 'Viewer', color: '#64748B', description: 'Read-only access to vendor risk data' },
];
const roleMeta = (role: string) => ROLES.find(r => r.value === role)
  || { value: role, label: role === 'compliance_officer' ? 'Compliance Officer' : role.replace(/_/g, ' '), color: '#64748B', description: '' };

// What each role can do, matching what the backend actually enforces (viewer / editor / admin tiers).
type Tier = 'all' | 'editor' | 'admin';
const PERMISSIONS: { label: string; detail: string; tier: Tier }[] = [
  { label: 'View vendors, scans and reports', detail: 'Every vendor page, scan result, report and dashboard', tier: 'all' },
  { label: 'Export data', detail: 'CSV and PDF exports across the platform', tier: 'all' },
  { label: 'Add and edit vendors, run scans', detail: 'Onboarding, vendor details, new scans, fourth parties', tier: 'editor' },
  { label: 'Send questionnaires and requests', detail: 'Questionnaires to vendors, pre-onboarding requests', tier: 'editor' },
  { label: 'Delete vendors and data', detail: 'Removing vendors, contacts and other records', tier: 'admin' },
  { label: 'Manage the team', detail: 'Invite, edit, deactivate and delete members', tier: 'admin' },
  { label: 'Platform settings and AI keys', detail: 'Organisation settings and AI provider credentials', tier: 'admin' },
];
const can = (role: string, tier: Tier) => tier === 'all' || (tier === 'editor' ? role !== 'viewer' : role === 'admin' || role === 'super_admin');

const DEPARTMENTS = ['IT', 'Security', 'Compliance', 'Risk Management', 'Finance', 'Legal', 'Operations', 'HR', 'Marketing', 'Sales'];
const LOCATIONS = ['North America', 'EMEA', 'APAC', 'LATAM', 'Global'];

/* ── types & helpers ────────────────────────────────────────────── */
interface Insight { owned_vendors: number; questionnaires_sent: number; requests_made: number; actions_30d: number; last_activity_at: string | null }
interface Activity { id: number; action: string; resource_type: string | null; details: string | null; created_at: string }
interface OwnedVendor { id: string; name: string; domain: string; score: number | null; risk_level: string | null }
// The drawer shows only a short preview of owned vendors (riskiest first); "View all" opens OwnedVendorsModal with the
// full list (search, risk filter, sort, pages, select and move), so hundreds of vendors never stretch the drawer.
const OWNED_PREVIEW = 5;
const OWNED_PAGE_SIZE = 25;
type RiskBucket = 'Critical' | 'High' | 'Medium' | 'Low' | 'Not scanned';
const RISK_BUCKETS: RiskBucket[] = ['Critical', 'High', 'Medium', 'Low', 'Not scanned'];
// Same bands as the platform score: Low >= 80, Medium >= 60, High >= 40, else Critical.
const riskBucket = (score: number | null): RiskBucket =>
  score == null ? 'Not scanned' : score >= 80 ? 'Low' : score >= 60 ? 'Medium' : score >= 40 ? 'High' : 'Critical';
const BUCKET_COLOR: Record<RiskBucket, string> = { Critical: '#DC2626', High: '#EA580C', Medium: '#D97706', Low: '#16A34A', 'Not scanned': '#94A3B8' };
type Status = 'active' | 'pending' | 'deactivated';
type StatusFilter = 'all' | Status;

const EMPTY_INSIGHT: Insight = { owned_vendors: 0, questionnaires_sent: 0, requests_made: 0, actions_30d: 0, last_activity_at: null };
const EMPTY_USERS: User[] = [];
const EMPTY_INSIGHTS: Record<string, Insight> = {};
// Member changes also show up on vendors (owner names, vendor ownership).
const USER_DATA: QueryKey[] = [['users'], ['vendors']];
const statusOf = (u: User): Status => (!u.is_active ? 'deactivated' : !u.last_login_at ? 'pending' : 'active');
const STATUS_META: Record<Status, { label: string; color: string }> = {
  active: { label: 'Active', color: '#16A34A' },
  pending: { label: 'Invite pending', color: '#D97706' },
  deactivated: { label: 'Deactivated', color: '#DC2626' },
};
const apiError = (e: any, fallback: string) => {
  const d = e?.response?.data?.detail;
  return typeof d === 'string' ? d : (d && typeof d === 'object' && typeof d.message === 'string') ? d.message : fallback;
};
const fmtDate = (v?: string | null) => (v ? new Date(v).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) : '—');
const fmtDateTime = (v?: string | null) => (v ? new Date(v).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '—');
const fmtRelative = (v?: string | null) => {
  if (!v) return null;
  const minutes = Math.round((Date.now() - new Date(v).getTime()) / 60000);
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes} min ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 24) return `${hours} hr ago`;
  const days = Math.round(hours / 24);
  if (days < 30) return `${days} day${days === 1 ? '' : 's'} ago`;
  return fmtDate(v);
};
const latest = (...dates: (string | null | undefined)[]) =>
  dates.filter(Boolean).sort((a, b) => new Date(b as string).getTime() - new Date(a as string).getTime())[0] || null;
const PALETTE = ['#2563EB', '#16A34A', '#D97706', '#7C3AED', '#DB2777', '#0D9488', '#4F46E5', '#EA580C'];
const hashColor = (t: string) => { let h = 0; for (let i = 0; i < t.length; i++) h = (h * 31 + t.charCodeAt(i)) >>> 0; return PALETTE[h % PALETTE.length]; };
const initials = (name: string) => name.split(/[\s@._-]+/).filter(Boolean).slice(0, 2).map(p => p[0].toUpperCase()).join('') || '?';
const prettyAction = (action: string) => {
  const [area, verb] = action.split('.');
  const words = `${(verb || area || '').replace(/_/g, ' ')}`;
  const subject = verb ? area.replace(/_/g, ' ') : '';
  const text = subject ? `${subject} ${words}` : words;
  return text.charAt(0).toUpperCase() + text.slice(1);
};

/* ── icons ──────────────────────────────────────────────────────── */
const Icon = ({ d, size = 14 }: { d: string; size?: number }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d={d} /></svg>
);
const I = {
  plus: 'M12 5v14M5 12h14', close: 'M6 6l12 12M18 6 6 18', search: 'M11 18a7 7 0 1 1 0-14 7 7 0 0 1 0 14ZM21 21l-4.3-4.3',
  download: 'M12 4v12M6 12l6 6 6-6M4 20h16', dots: 'M12 6h.01M12 12h.01M12 18h.01', check: 'M5 12l5 5L20 7',
  dash: 'M6 12h12', send: 'M22 2 11 13M22 2 15 22l-4-9-9-4 20-7Z', edit: 'M12 20h9M16.5 3.5a2.1 2.1 0 1 1 3 3L7 19l-4 1 1-4Z',
  block: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM5.6 5.6l12.8 12.8', trash: 'M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6',
  undo: 'M3 7v6h6M3 13a9 9 0 1 0 3-7', swap: 'M7 16V4M3 8l4-4 4 4M17 8v12M21 16l-4 4-4-4', chevron: 'M9 6l6 6-6 6',
  shield: 'M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3Z',
};

function Avatar({ name, size = 34 }: { name: string; size?: number }) {
  const c = hashColor(name);
  return (
    <span style={{ width: size, height: size, borderRadius: 99, flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', background: `${c}1f`, color: c, fontSize: size * 0.38, fontWeight: 700 }}>
      {initials(name)}
    </span>
  );
}

/* ═══════════════════════════════════════════════════════════════════ */
export default function Users() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const { user: currentUser, tenant } = useAuth();
  const { mode } = useCustomTheme();
  const isDark = mode === 'dark';

  const c = {
    ink: isDark ? '#e5e7eb' : T.ink, slate: isDark ? '#94a3b8' : T.slate, muted: isDark ? '#64748b' : T.muted,
    line: isDark ? '#1f1f1f' : T.bdr, surface: isDark ? '#0d0d0d' : T.surface, surface2: isDark ? '#141414' : T.surface2,
    accent: isDark ? '#3B82F6' : T.blue, bg: isDark ? '#000' : T.bg, selected: isDark ? '#0b1730' : T.blueBg,
  };

  const [accessDenied, setAccessDenied] = useState(false);
  const usersQuery = useQuery({
    queryKey: ['users', 'list', { include_inactive: true }],
    queryFn: async () => (await userApi.getUsers(true)).data as User[],
    enabled: !accessDenied,
  });
  const insightsQuery = useQuery({
    queryKey: ['users', 'team-insights'],
    queryFn: async () => {
      try { return ((await api.get('/v1/users/team-insights')).data.insights || {}) as Record<string, Insight>; }
      catch { return EMPTY_INSIGHTS; }
    },
    enabled: !accessDenied,
  });
  const users: User[] = usersQuery.data ?? EMPTY_USERS;
  const insights = insightsQuery.data ?? EMPTY_INSIGHTS;
  const loading = usersQuery.isPending;
  const [tab, setTab] = useState<'members' | 'roles'>('members');
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState<StatusFilter>('all');
  const [roleFilter, setRoleFilter] = useState('all');
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [inviteOpen, setInviteOpen] = useState(false);
  const [confirm, setConfirm] = useState<{ kind: 'deactivate' | 'delete'; user: User } | null>(null);
  const [menuFor, setMenuFor] = useState<string | null>(null);

  const maxUsers: number = tenant?.plan?.max_users ?? 3;
  const unlimited = maxUsers === -1;
  const seatsUsed = users.length;
  const seatsLeft = unlimited ? Infinity : Math.max(0, maxUsers - seatsUsed);
  const limitReached = !unlimited && seatsUsed >= maxUsers;

  useEffect(() => {
    if (currentUser && currentUser.role !== 'admin' && currentUser.role !== 'super_admin') setAccessDenied(true);
  }, [currentUser]);

  useEffect(() => {
    if (usersQuery.isError) enqueueSnackbar('Failed to load your team', { variant: 'error' });
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [usersQuery.isError, usersQuery.errorUpdatedAt]);

  const activateMutation = useMutation({ mutationFn: (u: User) => userApi.activateUser(u.id), meta: { invalidates: USER_DATA } });
  const resendMutation = useMutation({ mutationFn: (u: User) => userApi.resendInvite(u.id), meta: { invalidates: [['users']] } });

  useEffect(() => {
    if (!menuFor) return;
    const close = () => setMenuFor(null);
    window.addEventListener('click', close);
    return () => window.removeEventListener('click', close);
  }, [menuFor]);

  const insightOf = (u: User) => insights[u.id] || EMPTY_INSIGHT;
  const lastActive = (u: User) => latest(u.last_login_at, insightOf(u).last_activity_at);

  const counts = useMemo(() => ({
    all: users.length,
    active: users.filter(u => statusOf(u) === 'active').length,
    pending: users.filter(u => statusOf(u) === 'pending').length,
    deactivated: users.filter(u => statusOf(u) === 'deactivated').length,
  }), [users]);

  const oldestPending = useMemo(() => users.filter(u => statusOf(u) === 'pending')
    .map(u => u.created_at).sort()[0] || null, [users]);

  const visible = useMemo(() => {
    const needle = search.trim().toLowerCase();
    return users.filter(u => {
      if (statusFilter !== 'all' && statusOf(u) !== statusFilter) return false;
      if (roleFilter !== 'all' && u.role !== roleFilter) return false;
      if (!needle) return true;
      return [u.name, u.email, roleMeta(u.role).label, u.job_title, u.department].some(v => (v || '').toLowerCase().includes(needle));
    }).sort((a, b) => {
      const order = { active: 0, pending: 1, deactivated: 2 };
      return order[statusOf(a)] - order[statusOf(b)] || a.name.localeCompare(b.name);
    });
  }, [users, search, statusFilter, roleFilter]);

  const selected = users.find(u => u.id === selectedId) || null;

  /* ── actions ─────────────────────────────────────────────────── */
  const activate = async (u: User) => {
    try { await activateMutation.mutateAsync(u); enqueueSnackbar(`${u.name} is active again`, { variant: 'success' }); }
    catch (e) { enqueueSnackbar(apiError(e, 'Could not activate this member'), { variant: 'error' }); }
  };
  const resendInvite = async (u: User) => {
    try { await resendMutation.mutateAsync(u); enqueueSnackbar(`Invitation re-sent to ${u.email}`, { variant: 'success' }); }
    catch (e) { enqueueSnackbar(apiError(e, 'Could not resend the invitation'), { variant: 'error' }); }
  };

  const exportCsv = () => {
    const esc = (v: string) => `"${v.replace(/"/g, '""')}"`;
    const header = ['Name', 'Email', 'Role', 'Status', 'Job title', 'Department', 'Location', 'Vendors owned', 'Questionnaires sent', 'Actions (30d)', 'Last active', 'Joined'];
    const body = visible.map(u => {
      const ins = insightOf(u);
      return [u.name, u.email, roleMeta(u.role).label, STATUS_META[statusOf(u)].label, u.job_title || '', u.department || '', u.location || '',
        String(ins.owned_vendors), String(ins.questionnaires_sent), String(ins.actions_30d),
        lastActive(u) ? new Date(lastActive(u) as string).toISOString() : '', u.created_at ? new Date(u.created_at).toISOString().slice(0, 10) : '',
      ].map(esc).join(',');
    });
    const blob = new Blob([[header.join(','), ...body].join('\n')], { type: 'text/csv;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url; a.download = `team-${new Date().toISOString().slice(0, 10)}.csv`; a.click();
    URL.revokeObjectURL(url);
  };

  /* ── styles ──────────────────────────────────────────────────── */
  const pill = (color: string): React.CSSProperties => ({
    display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12, fontWeight: 600, padding: '4px 10px', borderRadius: 99,
    whiteSpace: 'nowrap', color, background: `${color}${isDark ? '22' : '12'}`, border: `1px solid ${color}38`,
  });
  const dot = (color: string): React.CSSProperties => ({ width: 6, height: 6, borderRadius: 99, background: color, flexShrink: 0 });
  const headCell: React.CSSProperties = {
    padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 600, letterSpacing: '.04em', textTransform: 'uppercase',
    color: c.slate, background: c.surface2, borderBottom: `1px solid ${c.line}`, whiteSpace: 'nowrap',
  };
  const cell: React.CSSProperties = { padding: '15px 16px', fontSize: 14, color: c.ink, borderBottom: `1px solid ${isDark ? '#1a1a1a' : '#EEF2F6'}`, verticalAlign: 'middle' };
  const segment = (active: boolean): React.CSSProperties => ({
    display: 'inline-flex', alignItems: 'center', gap: 6, padding: '7px 12px', fontSize: 13, fontWeight: 600, fontFamily: sans,
    cursor: 'pointer', border: 'none', borderRadius: 6, whiteSpace: 'nowrap', background: active ? c.surface : 'transparent', color: active ? c.ink : c.slate,
    boxShadow: active ? (isDark ? '0 0 0 1px #262626' : '0 1px 2px rgba(15,23,42,.08), 0 0 0 1px #E2E8F0') : 'none',
  });
  const badge = (tone?: string): React.CSSProperties => ({
    fontSize: 11, fontWeight: 700, padding: '1px 7px', borderRadius: 99, fontVariantNumeric: 'tabular-nums',
    background: tone ? `${tone}22` : (isDark ? '#1a1a1a' : '#EEF2F6'), color: tone || c.slate,
  });
  const selectStyle: React.CSSProperties = {
    padding: '8px 30px 8px 12px', fontSize: 13, fontFamily: sans, color: c.ink, background: c.surface, border: `1px solid ${c.line}`,
    borderRadius: 8, outline: 'none', cursor: 'pointer', appearance: 'none',
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%2394A3B8' stroke-width='1.5' fill='none'/%3E%3C/svg%3E")`,
    backgroundRepeat: 'no-repeat', backgroundPosition: 'right 11px center',
  };
  const menuItem = (danger = false): React.CSSProperties => ({
    display: 'flex', alignItems: 'center', gap: 10, width: '100%', padding: '9px 12px', fontSize: 13.5, fontFamily: sans, textAlign: 'left',
    background: 'none', border: 'none', borderRadius: 6, cursor: 'pointer', color: danger ? '#DC2626' : c.ink,
  });

  if (accessDenied) {
    return <AccessDeniedModal open onClose={() => { setAccessDenied(false); navigate('/dashboard'); }} pageName="Team (User Management)" />;
  }

  const kpis: { label: string; value: React.ReactNode; note: string; tone?: string; filter?: StatusFilter }[] = [
    { label: 'Members', value: counts.all, note: `${ROLES.filter(r => users.some(u => u.role === r.value)).length} roles in use`, filter: 'all' },
    { label: 'Active', value: counts.active, note: 'Signed in and working', tone: '#16A34A', filter: 'active' },
    { label: 'Invites pending', value: counts.pending, note: oldestPending ? `Oldest sent ${fmtRelative(oldestPending)}` : 'No open invitations', tone: counts.pending ? '#D97706' : undefined, filter: 'pending' },
    { label: 'Deactivated', value: counts.deactivated, note: counts.deactivated ? 'Can be reactivated any time' : 'None', filter: 'deactivated' },
  ];

  return (
    <div style={{ background: c.bg, minHeight: '100vh', padding: 24, fontFamily: sans }}>
      <style>{'@keyframes tmSlide { from { transform: translateX(16px); opacity: 0 } to { transform: none; opacity: 1 } } @keyframes tmPop { from { transform: translateY(6px) scale(.98); opacity: 0 } to { transform: none; opacity: 1 } } @keyframes tmShimmer { 0%,100% { opacity: .55 } 50% { opacity: 1 } }'}</style>

      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, flexWrap: 'wrap', marginBottom: 20 }}>
        <div>
          <div style={{ fontSize: 24, fontWeight: 700, color: c.ink, letterSpacing: '-.01em' }}>Team</div>
          <div style={{ fontSize: 14, color: c.slate, marginTop: 4, maxWidth: 620, lineHeight: 1.5 }}>
            Everyone in {tenant?.company_name || 'your organisation'} who works in FluxWatch -- their role, what they own and what they've been doing.
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <button onClick={exportCsv} disabled={!visible.length} style={{ ...topBtn(false, isDark), opacity: visible.length ? 1 : 0.5 }}><Icon d={I.download} /> Export CSV</button>
          <button onClick={() => setInviteOpen(true)} disabled={limitReached} title={limitReached ? 'Your plan has no free seats' : undefined}
            style={{ ...topBtn(true, isDark), opacity: limitReached ? 0.5 : 1, cursor: limitReached ? 'not-allowed' : 'pointer' }}>
            <Icon d={I.plus} /> Invite members
          </button>
        </div>
      </div>

      {limitReached && (
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '12px 16px', borderRadius: 10, marginBottom: 16, background: isDark ? '#1f1503' : T.ambBg, border: `1px solid ${isDark ? '#3b2a06' : T.ambBdr}`, color: isDark ? '#fbbf24' : T.amb, fontSize: 14 }}>
          <span><strong>All {maxUsers} seats are in use.</strong> Upgrade your plan, or delete someone who no longer needs access, to invite more people.</span>
          <button onClick={() => navigate('/settings')} style={{ ...topBtn(false, isDark), flexShrink: 0 }}>Upgrade plan</button>
        </div>
      )}

      {/* KPIs + seats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 18 }}>
        {kpis.map(k => {
          const active = !!k.filter && k.filter !== 'all' && statusFilter === k.filter;
          return (
            <div key={k.label} role="button" onClick={() => { setTab('members'); setStatusFilter(statusFilter === k.filter ? 'all' : (k.filter || 'all')); }}
              style={{ ...card(isDark), padding: '16px 18px', cursor: 'pointer', borderColor: active ? c.accent : undefined, boxShadow: active ? `0 0 0 1px ${c.accent}` : undefined }}>
              <div style={{ fontSize: 12.5, fontWeight: 600, color: c.slate, marginBottom: 8 }}>{k.label}</div>
              <div style={{ fontSize: 28, fontWeight: 700, color: k.tone || c.ink, lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>{loading ? '–' : k.value}</div>
              <div style={{ fontSize: 12, color: c.muted, marginTop: 8, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{k.note}</div>
            </div>
          );
        })}
        <div style={{ ...card(isDark), padding: '16px 18px' }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: c.slate, marginBottom: 8 }}>Seats</div>
          <div style={{ fontSize: 28, fontWeight: 700, color: limitReached ? '#DC2626' : c.ink, lineHeight: 1, fontVariantNumeric: 'tabular-nums' }}>
            {loading ? '–' : seatsUsed}<span style={{ fontSize: 16, color: c.muted, fontWeight: 600 }}> / {unlimited ? '∞' : maxUsers}</span>
          </div>
          {!unlimited && (
            <div style={{ height: 6, borderRadius: 99, background: isDark ? '#1f1f1f' : '#EEF2F6', marginTop: 10, overflow: 'hidden' }}>
              <div style={{ width: `${Math.min(100, (seatsUsed / Math.max(1, maxUsers)) * 100)}%`, height: '100%', borderRadius: 99, background: limitReached ? '#DC2626' : seatsUsed / maxUsers >= 0.8 ? '#D97706' : c.accent }} />
            </div>
          )}
          <div style={{ fontSize: 12, color: c.muted, marginTop: 8 }}>{unlimited ? 'Unlimited on your plan' : `${seatsLeft} left on the ${tenant?.plan?.plan_status || 'current'} plan`}</div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 24, borderBottom: `1px solid ${c.line}`, marginBottom: 16 }}>
        {([['members', `Members`], ['roles', 'Roles & permissions']] as const).map(([key, label]) => (
          <button key={key} onClick={() => setTab(key)} style={{
            background: 'none', border: 'none', padding: '10px 2px', fontSize: 14.5, fontWeight: 600, fontFamily: sans, cursor: 'pointer',
            color: tab === key ? c.ink : c.slate, borderBottom: `2px solid ${tab === key ? c.accent : 'transparent'}`, marginBottom: -1,
          }}>{label}</button>
        ))}
      </div>

      {tab === 'members' ? (
        <div style={{ ...card(isDark), padding: 0, overflow: 'visible' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '14px 16px', borderBottom: `1px solid ${c.line}`, flexWrap: 'wrap' }}>
            <div style={{ position: 'relative', flex: '1 1 240px', maxWidth: 340 }}>
              <span style={{ position: 'absolute', left: 11, top: '50%', transform: 'translateY(-50%)', color: c.muted, display: 'flex' }}><Icon d={I.search} /></span>
              <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Search name, email, role, department…"
                style={{ width: '100%', boxSizing: 'border-box', padding: '8px 12px 8px 32px', fontSize: 13.5, fontFamily: sans, color: c.ink, background: c.surface, border: `1px solid ${c.line}`, borderRadius: 8, outline: 'none' }} />
            </div>
            <div style={{ display: 'inline-flex', gap: 2, padding: 3, borderRadius: 8, background: c.surface2, border: `1px solid ${c.line}` }}>
              {([['all', 'All'], ['active', 'Active'], ['pending', 'Pending'], ['deactivated', 'Deactivated']] as [StatusFilter, string][]).map(([key, label]) => (
                <button key={key} style={segment(statusFilter === key)} onClick={() => setStatusFilter(key)}>
                  {label}<span style={badge(key === 'pending' && counts.pending ? '#D97706' : undefined)}>{counts[key]}</span>
                </button>
              ))}
            </div>
            <select value={roleFilter} onChange={e => setRoleFilter(e.target.value)} style={selectStyle}>
              <option value="all">All roles</option>
              {ROLES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
            </select>
            <span style={{ marginLeft: 'auto', fontSize: 12.5, color: c.slate }}>
              {visible.length === users.length ? `${users.length} member${users.length === 1 ? '' : 's'}` : `${visible.length} of ${users.length}`}
            </span>
          </div>

          {loading ? (
            <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 10 }}>
              {[0, 1, 2].map(i => <div key={i} style={{ height: 56, borderRadius: 8, background: c.surface2, animation: 'tmShimmer 1.2s infinite' }} />)}
            </div>
          ) : visible.length === 0 ? (
            <div style={{ padding: '56px 24px', textAlign: 'center' }}>
              <div style={{ fontSize: 15.5, fontWeight: 600, color: c.ink, marginBottom: 6 }}>No members match</div>
              <div style={{ fontSize: 13.5, color: c.slate, marginBottom: 14 }}>Try another status or role, or clear the search.</div>
              <button onClick={() => { setSearch(''); setStatusFilter('all'); setRoleFilter('all'); }} style={{ ...topBtn(false, isDark), margin: '0 auto' }}>Clear filters</button>
            </div>
          ) : (
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 960 }}>
                <thead>
                  <tr>
                    <th style={headCell}>Member</th>
                    <th style={headCell}>Role</th>
                    <th style={headCell}>Status</th>
                    <th style={headCell}>Owns</th>
                    <th style={headCell}>Last active</th>
                    <th style={headCell}>Joined</th>
                    <th style={{ ...headCell, width: 48 }} />
                  </tr>
                </thead>
                <tbody>
                  {visible.map(u => {
                    const status = statusOf(u);
                    const role = roleMeta(u.role);
                    const ins = insightOf(u);
                    const isSelf = u.id === currentUser?.id;
                    const last = lastActive(u);
                    const isOpen = u.id === selectedId;
                    return (
                      <tr key={u.id} onClick={() => setSelectedId(u.id)}
                        style={{ cursor: 'pointer', background: isOpen ? (isDark ? '#111827' : T.blueBg) : 'transparent', opacity: status === 'deactivated' ? 0.7 : 1 }}
                        onMouseEnter={e => { if (!isOpen) e.currentTarget.style.background = c.surface2; }}
                        onMouseLeave={e => { if (!isOpen) e.currentTarget.style.background = 'transparent'; }}>
                        <td style={{ ...cell, boxShadow: isOpen ? `inset 3px 0 0 ${c.accent}` : undefined }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                            <Avatar name={u.name || u.email} size={38} />
                            <div style={{ minWidth: 0 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontWeight: 600 }}>
                                {u.name}
                                {isSelf && <span style={{ fontSize: 11, fontWeight: 700, color: c.accent, background: isDark ? '#172554' : T.blueBg, borderRadius: 99, padding: '1px 8px' }}>You</span>}
                              </div>
                              <div style={{ fontSize: 12.5, color: c.muted, marginTop: 2 }}>
                                {u.email}{u.job_title || u.department ? ` · ${[u.job_title, u.department].filter(Boolean).join(', ')}` : ''}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={cell}><span style={pill(role.color)}>{role.label}</span></td>
                        <td style={cell}><span style={pill(STATUS_META[status].color)}><span style={dot(STATUS_META[status].color)} />{STATUS_META[status].label}</span></td>
                        <td style={cell}>
                          {ins.owned_vendors ? (
                            <span style={{ fontWeight: 600 }}>{ins.owned_vendors} vendor{ins.owned_vendors === 1 ? '' : 's'}</span>
                          ) : <span style={{ color: c.muted }}>—</span>}
                          {ins.questionnaires_sent > 0 && <div style={{ fontSize: 12, color: c.muted, marginTop: 2 }}>{ins.questionnaires_sent} questionnaire{ins.questionnaires_sent === 1 ? '' : 's'} sent</div>}
                        </td>
                        <td style={{ ...cell, whiteSpace: 'nowrap' }} title={fmtDateTime(last)}>
                          {last ? <>{fmtRelative(last)}{ins.actions_30d > 0 && <div style={{ fontSize: 12, color: c.muted, marginTop: 2 }}>{ins.actions_30d} actions in 30 days</div>}</>
                            : <span style={{ color: c.muted }}>{status === 'pending' ? 'Not signed in yet' : 'Never'}</span>}
                        </td>
                        <td style={{ ...cell, whiteSpace: 'nowrap', color: c.slate }}>{fmtDate(u.created_at)}</td>
                        <td style={{ ...cell, position: 'relative' }} onClick={e => e.stopPropagation()}>
                          <button onClick={e => { e.stopPropagation(); setMenuFor(menuFor === u.id ? null : u.id); }} aria-label="More actions"
                            style={{ width: 32, height: 32, borderRadius: 8, border: `1px solid ${menuFor === u.id ? c.line : 'transparent'}`, background: menuFor === u.id ? c.surface2 : 'transparent', color: c.slate, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Icon d={I.dots} size={18} />
                          </button>
                          {menuFor === u.id && (
                            <div onClick={e => e.stopPropagation()} style={{ position: 'absolute', right: 12, top: 46, zIndex: 20, width: 210, padding: 6, background: c.surface, border: `1px solid ${c.line}`, borderRadius: 10, boxShadow: isDark ? '0 10px 30px rgba(0,0,0,.6)' : '0 10px 30px rgba(15,23,42,.12)' }}>
                              <button style={menuItem()} onClick={() => { setMenuFor(null); setSelectedId(u.id); }}><Icon d={I.edit} /> View & edit</button>
                              {status === 'pending' && <button style={menuItem()} onClick={() => { setMenuFor(null); resendInvite(u); }}><Icon d={I.send} /> Resend invitation</button>}
                              {status === 'deactivated'
                                ? <button style={menuItem()} onClick={() => { setMenuFor(null); activate(u); }}><Icon d={I.undo} /> Reactivate</button>
                                : !isSelf && <button style={menuItem(true)} onClick={() => { setMenuFor(null); setConfirm({ kind: 'deactivate', user: u }); }}><Icon d={I.block} /> Deactivate</button>}
                              {!isSelf && (
                                <>
                                  <div style={{ height: 1, background: c.line, margin: '4px 0' }} />
                                  <button style={menuItem(true)} onClick={() => { setMenuFor(null); setConfirm({ kind: 'delete', user: u }); }}><Icon d={I.trash} /> Delete permanently</button>
                                </>
                              )}
                            </div>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      ) : (
        <RolesMatrix users={users} isDark={isDark} />
      )}

      {selected && (
        <MemberDrawer
          key={selected.id} member={selected} insight={insightOf(selected)} isSelf={selected.id === currentUser?.id} isDark={isDark}
          teammates={users.filter(u => u.is_active && u.id !== selected.id)}
          onClose={() => setSelectedId(null)}
          onResend={() => resendInvite(selected)} onActivate={() => activate(selected)}
          onDeactivate={() => setConfirm({ kind: 'deactivate', user: selected })} onDelete={() => setConfirm({ kind: 'delete', user: selected })}
        />
      )}

      {inviteOpen && (
        <InviteDrawer isDark={isDark} seatsLeft={seatsLeft} existingEmails={users.map(u => u.email.toLowerCase())}
          onClose={() => setInviteOpen(false)}
          onDone={(created) => { setInviteOpen(false); if (created) enqueueSnackbar(`${created} member${created === 1 ? '' : 's'} invited`, { variant: 'success' }); }} />
      )}

      {confirm && (
        <ConfirmAction
          kind={confirm.kind} member={confirm.user} ownedVendors={insightOf(confirm.user).owned_vendors} isDark={isDark}
          teammates={users.filter(u => u.is_active && u.id !== confirm.user.id)} currentUserId={currentUser?.id}
          onClose={() => setConfirm(null)}
          onDone={(message) => {
            if (confirm.kind === 'delete' && selectedId === confirm.user.id) setSelectedId(null);
            setConfirm(null); enqueueSnackbar(message, { variant: 'success' });
          }}
        />
      )}
    </div>
  );
}

/* ── Roles & permissions ─────────────────────────────────────────── */
function RolesMatrix({ users, isDark }: { users: User[]; isDark: boolean }) {
  const ink = isDark ? '#e5e7eb' : T.ink, slate = isDark ? '#94a3b8' : T.slate, muted = isDark ? '#64748b' : T.muted;
  const line = isDark ? '#1f1f1f' : T.bdr, surface2 = isDark ? '#141414' : T.surface2;
  return (
    <div style={{ ...card(isDark), padding: 0, overflow: 'hidden' }}>
      <div style={{ padding: '16px 20px', borderBottom: `1px solid ${line}`, display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ color: isDark ? '#3B82F6' : T.blue, display: 'flex' }}><Icon d={I.shield} size={18} /></span>
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: ink }}>What each role can do</div>
          <div style={{ fontSize: 13, color: slate, marginTop: 2 }}>These are the permissions the platform enforces on every request, not just what the screens show.</div>
        </div>
      </div>
      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 860 }}>
          <thead>
            <tr>
              <th style={{ padding: '14px 20px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: slate, background: surface2, borderBottom: `1px solid ${line}`, width: '34%' }}>Permission</th>
              {ROLES.map(r => {
                const members = users.filter(u => u.role === r.value && u.is_active);
                return (
                  <th key={r.value} style={{ padding: '14px 12px', textAlign: 'center', background: surface2, borderBottom: `1px solid ${line}`, verticalAlign: 'top' }}>
                    <div style={{ fontSize: 13.5, fontWeight: 700, color: r.color }}>{r.label}</div>
                    <div style={{ fontSize: 11.5, color: muted, fontWeight: 500, marginTop: 3 }}>{members.length} member{members.length === 1 ? '' : 's'}</div>
                    {members.length > 0 && (
                      <div style={{ display: 'flex', justifyContent: 'center', marginTop: 6 }}>
                        {members.slice(0, 4).map((m, i) => <span key={m.id} title={m.name} style={{ marginLeft: i ? -6 : 0, borderRadius: 99, boxShadow: `0 0 0 2px ${surface2}` }}><Avatar name={m.name || m.email} size={22} /></span>)}
                      </div>
                    )}
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {PERMISSIONS.map(p => (
              <tr key={p.label}>
                <td style={{ padding: '14px 20px', borderBottom: `1px solid ${line}` }}>
                  <div style={{ fontSize: 14, fontWeight: 600, color: ink }}>{p.label}</div>
                  <div style={{ fontSize: 12.5, color: muted, marginTop: 2 }}>{p.detail}</div>
                </td>
                {ROLES.map(r => {
                  const ok = can(r.value, p.tier);
                  return (
                    <td key={r.value} style={{ textAlign: 'center', borderBottom: `1px solid ${line}` }}>
                      <span style={{ display: 'inline-flex', width: 26, height: 26, borderRadius: 99, alignItems: 'center', justifyContent: 'center', color: ok ? '#16A34A' : muted, background: ok ? `#16A34A${isDark ? '22' : '14'}` : 'transparent' }}>
                        <Icon d={ok ? I.check : I.dash} size={15} />
                      </span>
                    </td>
                  );
                })}
              </tr>
            ))}
            <tr>
              <td style={{ padding: '14px 20px', fontSize: 12.5, color: muted }}>Role description</td>
              {ROLES.map(r => <td key={r.value} style={{ padding: '14px 12px', fontSize: 12, color: slate, textAlign: 'center', lineHeight: 1.45 }}>{r.description}</td>)}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

/* ── Shared drawer shell ─────────────────────────────────────────── */
function DrawerShell({ isDark, width = 640, onClose, children }: { isDark: boolean; width?: number; onClose: () => void; children: React.ReactNode }) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);
  return (
    <>
      <div onClick={onClose} style={{ position: 'fixed', top: 64, left: 0, right: 0, bottom: 0, background: 'rgba(15,23,42,.35)', zIndex: 1200 }} />
      <aside style={{
        position: 'fixed', top: 64, right: 0, bottom: 0, width, maxWidth: '100%', zIndex: 1201, display: 'flex', flexDirection: 'column',
        background: isDark ? '#0d0d0d' : T.surface, borderLeft: `1px solid ${isDark ? '#1f1f1f' : T.bdr}`, fontFamily: sans, animation: 'tmSlide .18s ease-out',
      }}>
        {children}
      </aside>
    </>
  );
}

function RoleCards({ value, onChange, isDark, disabled }: { value: string; onChange: (v: string) => void; isDark: boolean; disabled?: boolean }) {
  const ink = isDark ? '#e5e7eb' : T.ink, slate = isDark ? '#94a3b8' : T.slate, line = isDark ? '#1f1f1f' : T.bdr;
  const accent = isDark ? '#3B82F6' : T.blue;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 8 }}>
      {ROLES.map(r => {
        const on = r.value === value;
        return (
          <button key={r.value} type="button" disabled={disabled} onClick={() => onChange(r.value)} style={{
            display: 'flex', gap: 10, alignItems: 'flex-start', textAlign: 'left', padding: '12px 14px', borderRadius: 10, fontFamily: sans,
            cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled && !on ? 0.5 : 1,
            border: `1.5px solid ${on ? accent : line}`, background: on ? (isDark ? '#0b1730' : T.blueBg) : 'transparent',
          }}>
            <span style={{ width: 18, height: 18, borderRadius: 99, flexShrink: 0, marginTop: 1, border: `2px solid ${on ? accent : (isDark ? '#333' : T.faint)}`, display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
              {on && <span style={{ width: 8, height: 8, borderRadius: 99, background: accent }} />}
            </span>
            <span>
              <span style={{ display: 'block', fontSize: 14, fontWeight: 700, color: on ? accent : ink }}>{r.label}</span>
              <span style={{ display: 'block', fontSize: 12.5, color: slate, marginTop: 2, lineHeight: 1.4 }}>{r.description}</span>
            </span>
          </button>
        );
      })}
    </div>
  );
}

function PermissionList({ role, isDark }: { role: string; isDark: boolean }) {
  const ink = isDark ? '#e5e7eb' : T.ink, muted = isDark ? '#64748b' : T.muted;
  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(240px, 1fr))', gap: 6 }}>
      {PERMISSIONS.map(p => {
        const ok = can(role, p.tier);
        return (
          <div key={p.label} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13.5, color: ok ? ink : muted, textDecoration: ok ? 'none' : 'line-through' }}>
            <span style={{ color: ok ? '#16A34A' : muted, display: 'flex' }}><Icon d={ok ? I.check : I.dash} size={14} /></span>{p.label}
          </div>
        );
      })}
    </div>
  );
}

/* ── Member drawer: profile, access, ownership, activity, edit ───── */
function MemberDrawer({ member, insight, isSelf, isDark, teammates, onClose, onResend, onActivate, onDeactivate, onDelete }: {
  member: User; insight: Insight; isSelf: boolean; isDark: boolean; teammates: User[];
  onClose: () => void; onResend: () => void; onActivate: () => void; onDeactivate: () => void; onDelete: () => void;
}) {
  const { enqueueSnackbar } = useSnackbar();
  const ink = isDark ? '#e5e7eb' : T.ink, slate = isDark ? '#94a3b8' : T.slate, muted = isDark ? '#64748b' : T.muted;
  const line = isDark ? '#1f1f1f' : T.bdr, surface = isDark ? '#0d0d0d' : T.surface, surface2 = isDark ? '#141414' : T.surface2;
  const accent = isDark ? '#3B82F6' : T.blue;

  const [editing, setEditing] = useState(false);
  const [form, setForm] = useState<UpdateUserData>({});
  const [transferTo, setTransferTo] = useState('');
  const [ownedOpen, setOwnedOpen] = useState(false);
  const [confirmTransfer, setConfirmTransfer] = useState(false);
  const [drawerTab, setDrawerTab] = useState<'overview' | 'sessions'>('overview');
  const navigate = useNavigate();

  const activityQuery = useQuery({
    queryKey: ['users', 'detail', member.id, 'activity', { limit: 20 }],
    queryFn: async () => {
      try { return ((await api.get(`/v1/users/${member.id}/activity`, { params: { limit: 20 } })).data.activity || []) as Activity[]; }
      catch { return [] as Activity[]; }
    },
  });
  const vendorsQuery = useQuery({
    queryKey: ['users', 'detail', member.id, 'vendors'],
    queryFn: async () => {
      try { return ((await api.get(`/v1/users/${member.id}/vendors`)).data.vendors || []) as OwnedVendor[]; }
      catch { return [] as OwnedVendor[]; }
    },
  });
  const activity = activityQuery.data ?? null;
  const vendors = vendorsQuery.data ?? null;

  const saveMutation = useMutation({
    mutationFn: (changes: UpdateUserData) => userApi.updateUser(member.id, changes),
    meta: { invalidates: USER_DATA },
  });
  const transferMutation = useMutation({
    mutationFn: async (to: string) => (await api.post(`/v1/users/${member.id}/transfer-vendors`, { to_user_id: to || null })).data as { transferred: number },
    meta: { invalidates: USER_DATA },
  });
  const saving = saveMutation.isPending;
  const transferring = transferMutation.isPending;

  const startEdit = () => {
    setForm({
      name: member.name, role: member.role, job_title: member.job_title || '', department: member.department || '',
      phone_number: member.phone_number || '', location: member.location || '',
      receive_notifications: !!member.receive_notifications, api_access: !!member.api_access,
    });
    setEditing(true);
  };

  const save = async () => {
    if (!(form.name || '').trim()) { enqueueSnackbar('Name is required', { variant: 'warning' }); return; }
    const changes: UpdateUserData = {};
    (Object.keys(form) as (keyof UpdateUserData)[]).forEach(key => {
      const before = (member as any)[key] ?? (typeof form[key] === 'boolean' ? false : '');
      if (form[key] !== undefined && form[key] !== before) (changes as any)[key] = form[key];
    });
    if (!Object.keys(changes).length) { setEditing(false); return; }
    try {
      await saveMutation.mutateAsync(changes);
      enqueueSnackbar('Changes saved', { variant: 'success' });
      setEditing(false);
    } catch (e) {
      enqueueSnackbar(apiError(e, 'Could not save changes'), { variant: 'error' });
    }
  };

  const transfer = async () => {
    try {
      const data = await transferMutation.mutateAsync(transferTo);
      const to = teammates.find(t => t.id === transferTo);
      enqueueSnackbar(to ? `${data.transferred} vendor(s) moved to ${to.name}` : `${data.transferred} vendor(s) unassigned`, { variant: 'success' });
      setTransferTo('');
    } catch (e) {
      enqueueSnackbar(apiError(e, 'Could not transfer the vendors'), { variant: 'error' });
    } finally {
      setConfirmTransfer(false);
    }
  };

  const status = statusOf(member);
  const role = roleMeta(member.role);
  const sectionLabel: React.CSSProperties = { fontSize: 11.5, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: slate, marginBottom: 12 };
  const input: React.CSSProperties = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', fontSize: 14, fontFamily: sans, color: ink, background: surface, border: `1px solid ${line}`, borderRadius: 8, outline: 'none' };
  const label: React.CSSProperties = { display: 'block', fontSize: 13, fontWeight: 600, color: ink, marginBottom: 6 };
  const actionBtn = (danger = false): React.CSSProperties => ({ ...topBtn(false, isDark), color: danger ? '#DC2626' : undefined, padding: '7px 12px', fontSize: 13 });
  const toggle = (on: boolean) => (
    <span style={{ width: 36, height: 20, borderRadius: 99, background: on ? accent : (isDark ? '#333' : T.faint), position: 'relative', flexShrink: 0, transition: 'background .15s' }}>
      <span style={{ position: 'absolute', top: 2, left: on ? 18 : 2, width: 16, height: 16, borderRadius: 99, background: '#fff', transition: 'left .15s' }} />
    </span>
  );

  return (
    <DrawerShell isDark={isDark} onClose={onClose}>
      {/* header */}
      <div style={{ padding: '22px 26px 18px', borderBottom: `1px solid ${line}` }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, minWidth: 0 }}>
            <Avatar name={member.name || member.email} size={52} />
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 20, fontWeight: 700, color: ink, display: 'flex', alignItems: 'center', gap: 8 }}>
                {member.name}
                {isSelf && <span style={{ fontSize: 11, fontWeight: 700, color: accent, background: isDark ? '#172554' : T.blueBg, borderRadius: 99, padding: '2px 8px' }}>You</span>}
              </div>
              <div style={{ fontSize: 14, color: slate, marginTop: 2 }}>{member.email}</div>
              <div style={{ display: 'flex', gap: 6, marginTop: 8 }}>
                <span style={{ fontSize: 12, fontWeight: 600, padding: '3px 10px', borderRadius: 99, color: role.color, background: `${role.color}${isDark ? '22' : '12'}`, border: `1px solid ${role.color}38` }}>{role.label}</span>
                <span style={{ fontSize: 12, fontWeight: 600, padding: '3px 10px', borderRadius: 99, color: STATUS_META[status].color, background: `${STATUS_META[status].color}${isDark ? '22' : '12'}`, border: `1px solid ${STATUS_META[status].color}38` }}>{STATUS_META[status].label}</span>
              </div>
            </div>
          </div>
          <button onClick={onClose} aria-label="Close" title="Close (Esc)" style={{ background: surface2, border: `1px solid ${line}`, color: slate, cursor: 'pointer', width: 32, height: 32, borderRadius: 8, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <Icon d={I.close} />
          </button>
        </div>
        {!editing && (
          <div style={{ display: 'flex', gap: 8, marginTop: 16, flexWrap: 'wrap' }}>
            <button onClick={startEdit} style={actionBtn()}><Icon d={I.edit} /> Edit</button>
            {status === 'pending' && <button onClick={onResend} style={actionBtn()}><Icon d={I.send} /> Resend invitation</button>}
            {status === 'deactivated' && <button onClick={onActivate} style={actionBtn()}><Icon d={I.undo} /> Reactivate</button>}
            {status !== 'deactivated' && !isSelf && <button onClick={onDeactivate} style={actionBtn(true)}><Icon d={I.block} /> Deactivate</button>}
            {!isSelf && <button onClick={onDelete} style={actionBtn(true)}><Icon d={I.trash} /> Delete</button>}
          </div>
        )}
        {!editing && (
          <div role="tablist" style={{ display: 'flex', gap: 4, marginTop: 18, marginBottom: -18 }}>
            {(['overview', 'sessions'] as const).map(t => (
              <button key={t} role="tab" aria-selected={drawerTab === t} onClick={() => setDrawerTab(t)} style={{
                background: 'none', border: 'none', borderBottom: `2px solid ${drawerTab === t ? accent : 'transparent'}`,
                padding: '8px 4px', marginRight: 14, cursor: 'pointer', fontFamily: sans, fontSize: 14,
                fontWeight: drawerTab === t ? 700 : 500, color: drawerTab === t ? ink : slate,
              }}>{t === 'overview' ? 'Overview' : 'Sessions'}</button>
            ))}
          </div>
        )}
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '22px 26px', display: 'flex', flexDirection: 'column', gap: 26 }}>
        {editing ? (
          <>
            <section>
              <div style={sectionLabel}>Profile</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
                <div style={{ gridColumn: '1 / -1' }}><label style={label}>Full name</label><input style={input} value={form.name || ''} onChange={e => setForm({ ...form, name: e.target.value })} /></div>
                <div><label style={label}>Job title</label><input style={input} value={form.job_title || ''} onChange={e => setForm({ ...form, job_title: e.target.value })} placeholder="e.g. Security Analyst" /></div>
                <div><label style={label}>Phone</label><PhoneNumberInput inputStyle={input} value={form.phone_number || ''} onChange={v => setForm({ ...form, phone_number: v })} placeholder="555 0100" /></div>
                <div><label style={label}>Department</label>
                  <select style={input} value={form.department || ''} onChange={e => setForm({ ...form, department: e.target.value })}>
                    <option value="">—</option>{DEPARTMENTS.map(d => <option key={d}>{d}</option>)}
                  </select></div>
                <div><label style={label}>Location</label>
                  <select style={input} value={form.location || ''} onChange={e => setForm({ ...form, location: e.target.value })}>
                    <option value="">—</option>{LOCATIONS.map(l => <option key={l}>{l}</option>)}
                  </select></div>
              </div>
            </section>
            <section>
              <div style={sectionLabel}>Role</div>
              <RoleCards value={form.role || 'viewer'} onChange={v => setForm({ ...form, role: v })} isDark={isDark} disabled={isSelf} />
              {isSelf && <div style={{ fontSize: 12.5, color: muted, marginTop: 8 }}>You can't change your own role -- ask another admin.</div>}
            </section>
            <section>
              <div style={sectionLabel}>Preferences</div>
              {([['receive_notifications', 'Security and risk notifications', 'Email alerts about new critical findings and score drops'],
                 ['api_access', 'API access', 'Can create API keys and call the FluxWatch API']] as [keyof UpdateUserData, string, string][]).map(([key, title, hint]) => (
                <div key={key} role="button" onClick={() => setForm({ ...form, [key]: !form[key] })} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '12px 0', borderTop: `1px solid ${line}`, cursor: 'pointer' }}>
                  <div><div style={{ fontSize: 14, fontWeight: 600, color: ink }}>{title}</div><div style={{ fontSize: 12.5, color: slate, marginTop: 2 }}>{hint}</div></div>
                  {toggle(!!form[key])}
                </div>
              ))}
            </section>
          </>
        ) : drawerTab === 'sessions' ? (
          <MemberSessions memberId={member.id} memberName={member.name || member.email} isSelf={isSelf} isDark={isDark} />
        ) : (
          <>
            <section style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 10 }}>
              {[['Vendors owned', insight.owned_vendors], ['Questionnaires sent', insight.questionnaires_sent], ['Requests filed', insight.requests_made], ['Actions · 30 days', insight.actions_30d]].map(([l, v]) => (
                <div key={l as string} style={{ border: `1px solid ${line}`, borderRadius: 10, padding: '12px 14px' }}>
                  <div style={{ fontSize: 22, fontWeight: 700, color: ink, fontVariantNumeric: 'tabular-nums' }}>{v}</div>
                  <div style={{ fontSize: 12, color: slate, marginTop: 4 }}>{l}</div>
                </div>
              ))}
            </section>

            <section>
              <div style={sectionLabel}>Details</div>
              <div style={{ border: `1px solid ${line}`, borderRadius: 10, overflow: 'hidden' }}>
                {([['Job title', member.job_title], ['Department', member.department], ['Location', member.location], ['Phone', member.phone_number],
                   ['Joined', fmtDate(member.created_at)], ['Last sign-in', member.last_login_at ? `${fmtDateTime(member.last_login_at)} (${fmtRelative(member.last_login_at)})` : status === 'pending' ? 'Has not signed in yet' : 'Never'],
                   ['Notifications', member.receive_notifications ? 'On' : 'Off'], ['API access', member.api_access ? 'Allowed' : 'Not allowed']] as [string, any][]).map(([k, v], i) => (
                  <div key={k} style={{ display: 'grid', gridTemplateColumns: '150px 1fr', gap: 12, padding: '11px 16px', borderTop: i ? `1px solid ${line}` : 'none', background: i % 2 ? 'transparent' : surface2 }}>
                    <span style={{ fontSize: 13.5, color: slate }}>{k}</span>
                    <span style={{ fontSize: 14.5, color: v ? ink : muted }}>{v || '—'}</span>
                  </div>
                ))}
              </div>
            </section>

            <section>
              <div style={sectionLabel}>Access · {role.label}</div>
              <PermissionList role={member.role} isDark={isDark} />
            </section>

            <section>
              <div style={{ ...sectionLabel, display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                <span>Vendors owned{vendors ? ` (${vendors.length})` : ''}</span>
                {vendors && vendors.length > 0 && (
                  <button onClick={() => setOwnedOpen(true)} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: sans,
                    fontSize: 12.5, fontWeight: 600, color: accent, textTransform: 'none', letterSpacing: 0 }}>
                    View all
                  </button>
                )}
              </div>
              {vendors === null ? <div style={{ height: 48, borderRadius: 10, background: surface2, animation: 'tmShimmer 1.2s infinite' }} />
                : vendors.length === 0 ? <div style={{ fontSize: 14, color: slate }}>Not the owner of any vendor.</div>
                : (() => {
                  const counts = RISK_BUCKETS.map(b => [b, vendors.filter(v => riskBucket(v.score) === b).length] as const).filter(([, n]) => n > 0);
                  // A short preview, riskiest first; the full list opens in the popup.
                  const preview = [...vendors].sort((a, b) => (a.score ?? 101) - (b.score ?? 101) || a.name.localeCompare(b.name)).slice(0, OWNED_PREVIEW);
                  return (
                  <>
                    <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginBottom: 10, fontSize: 12.5, color: slate }}>
                      {counts.map(([b, n]) => (
                        <span key={b} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                          <span style={{ width: 7, height: 7, borderRadius: '50%', background: BUCKET_COLOR[b] }} />
                          <strong style={{ color: ink }}>{n}</strong> {b === 'Not scanned' ? 'not scanned' : b.toLowerCase()}
                        </span>
                      ))}
                    </div>
                    <div style={{ border: `1px solid ${line}`, borderRadius: 10, overflow: 'hidden' }}>
                      {preview.map((v, i) => (
                        <div key={v.id} role="button" onClick={() => navigate(`/vendors/${v.id}`)} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 16px', borderTop: i ? `1px solid ${line}` : 'none', cursor: 'pointer' }}>
                          <img src={`https://www.google.com/s2/favicons?domain=${v.domain}&sz=64`} alt="" style={{ width: 22, height: 22, objectFit: 'contain' }} />
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{ fontSize: 14, fontWeight: 600, color: ink, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{v.name}</div>
                            <div style={{ fontSize: 12.5, color: muted }}>{v.domain}</div>
                          </div>
                          {v.score != null
                            ? <span style={{ fontSize: 13, fontWeight: 700, color: BUCKET_COLOR[riskBucket(v.score)] }}>{v.score}<span style={{ color: muted, fontWeight: 500 }}>/100</span></span>
                            : <span style={{ fontSize: 12.5, color: muted }}>Not scanned</span>}
                          <span style={{ color: muted, display: 'flex' }}><Icon d={I.chevron} /></span>
                        </div>
                      ))}
                      {vendors.length > preview.length && (
                        <button onClick={() => setOwnedOpen(true)} style={{ display: 'block', width: '100%', padding: '10px 16px', border: 'none', borderTop: `1px solid ${line}`,
                          background: surface2, cursor: 'pointer', fontFamily: sans, fontSize: 13, fontWeight: 600, color: accent, textAlign: 'left' }}>
                          View all {vendors.length} vendors
                        </button>
                      )}
                    </div>
                    <div style={{ display: 'flex', gap: 8, marginTop: 10, alignItems: 'center' }}>
                      <select value={transferTo} onChange={e => setTransferTo(e.target.value)} style={{ ...input, flex: 1, padding: '8px 10px', fontSize: 13.5 }}>
                        <option value="">Leave unassigned</option>
                        {teammates.map(t => <option key={t.id} value={t.id}>{t.name} ({roleMeta(t.role).label})</option>)}
                      </select>
                      <button onClick={() => setConfirmTransfer(true)} disabled={transferring} style={{ ...topBtn(false, isDark), padding: '8px 12px', fontSize: 13, flexShrink: 0 }}>
                        <Icon d={I.swap} /> {transferring ? 'Moving…' : `Transfer all ${vendors.length}`}
                      </button>
                    </div>
                    {confirmTransfer && (
                      <ConfirmMoveDialog isDark={isDark} fromName={member.name} vendors={vendors}
                        toName={teammates.find(t => t.id === transferTo)?.name ?? null} busy={transferring}
                        onCancel={() => setConfirmTransfer(false)} onConfirm={transfer} />
                    )}
                    {vendors.length > 1 && (
                      <div style={{ fontSize: 12, color: muted, marginTop: 6 }}>To move only some vendors, open View all and select them.</div>
                    )}
                    {ownedOpen && (
                      <OwnedVendorsModal member={member} vendors={vendors} teammates={teammates} isDark={isDark}
                        onClose={() => setOwnedOpen(false)} onOpenVendor={id => navigate(`/vendors/${id}`)} />
                    )}
                  </>
                  );
                })()}
            </section>

            <section>
              <div style={sectionLabel}>Recent activity</div>
              {activity === null ? <div style={{ height: 90, borderRadius: 10, background: surface2, animation: 'tmShimmer 1.2s infinite' }} />
                : activity.length === 0 ? <div style={{ fontSize: 14, color: slate }}>No recorded activity yet.</div>
                : (
                  <div style={{ position: 'relative', paddingLeft: 18 }}>
                    <div style={{ position: 'absolute', left: 5, top: 6, bottom: 6, width: 2, background: line, borderRadius: 2 }} />
                    {activity.map(a => (
                      <div key={a.id} style={{ position: 'relative', paddingBottom: 14 }}>
                        <span style={{ position: 'absolute', left: -18, top: 5, width: 12, height: 12, borderRadius: 99, background: surface, border: `2px solid ${accent}` }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                          <span style={{ fontSize: 14, fontWeight: 600, color: ink }}>{prettyAction(a.action)}</span>
                          <span style={{ fontSize: 12, color: muted, whiteSpace: 'nowrap' }} title={fmtDateTime(a.created_at)}>{fmtRelative(a.created_at)}</span>
                        </div>
                        {a.details && <div style={{ fontSize: 13, color: slate, marginTop: 2, lineHeight: 1.45 }}>{a.details}</div>}
                      </div>
                    ))}
                  </div>
                )}
            </section>
          </>
        )}
      </div>

      {editing && (
        <div style={{ padding: '14px 26px', borderTop: `1px solid ${line}`, background: surface2, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={() => setEditing(false)} disabled={saving} style={topBtn(false, isDark)}>Cancel</button>
          <button onClick={save} disabled={saving} style={{ ...topBtn(true, isDark), opacity: saving ? 0.7 : 1 }}>{saving ? 'Saving…' : 'Save changes'}</button>
        </div>
      )}
    </DrawerShell>
  );
}

/* ── Member sessions: sign-ins that are live right now, with IP and device ── */
interface LiveSession {
  id: string; ip_address: string | null; browser: string | null; os: string | null; user_agent: string | null;
  signed_in_at: string | null; last_active_at: string | null; expires_at: string | null; is_current: boolean;
}

function MemberSessions({ memberId, memberName, isSelf, isDark }: { memberId: string; memberName: string; isSelf: boolean; isDark: boolean }) {
  const { enqueueSnackbar } = useSnackbar();
  const ink = isDark ? '#e5e7eb' : T.ink, slate = isDark ? '#94a3b8' : T.slate, muted = isDark ? '#64748b' : T.muted;
  const line = isDark ? '#1f1f1f' : T.bdr, surface2 = isDark ? '#141414' : T.surface2;
  const green = isDark ? '#4ADE80' : '#15803D';
  const key = ['users', 'detail', memberId, 'sessions'];
  const sessionsQuery = useQuery({
    queryKey: key,
    queryFn: async () => (await api.get(`/v1/users/${memberId}/sessions`)).data as { sessions: LiveSession[]; timeout_hours: number },
    refetchInterval: 30_000,
  });
  // 'all' or one session id waiting for confirmation
  const [confirming, setConfirming] = useState<string | null>(null);
  const endMutation = useMutation({
    mutationFn: async (target: string) =>
      (await api.delete(target === 'all' ? `/v1/users/${memberId}/sessions` : `/v1/users/${memberId}/sessions/${target}`)).data as { removed: number },
    meta: { invalidates: [key] },
  });
  const end = async (target: string) => {
    try {
      const { removed } = await endMutation.mutateAsync(target);
      enqueueSnackbar(target === 'all' ? `${removed} session${removed === 1 ? '' : 's'} ended` : 'Session ended', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(apiError(e, 'Could not end the session'), { variant: 'error' });
    } finally {
      setConfirming(null);
    }
  };
  const busy = endMutation.isPending;
  const dangerBtn: React.CSSProperties = { ...topBtn(false, isDark), padding: '5px 10px', fontSize: 12.5, color: '#DC2626' };

  if (sessionsQuery.isPending) return <div style={{ height: 120, borderRadius: 10, background: surface2, animation: 'tmShimmer 1.2s infinite' }} />;
  if (sessionsQuery.isError) return <div style={{ fontSize: 14, color: '#DC2626' }}>{apiError(sessionsQuery.error, 'Could not load sessions.')}</div>;

  const { sessions, timeout_hours } = sessionsQuery.data;
  const idleWindow = timeout_hours >= 1 ? `${timeout_hours} hour${timeout_hours === 1 ? '' : 's'}` : `${Math.round(timeout_hours * 60)} minutes`;
  return (
    <section>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10, marginBottom: 6 }}>
        <div style={{ fontSize: 11.5, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: slate }}>
          Active sessions ({sessions.length})
        </div>
        {sessions.length > 1 && (
          confirming === 'all' ? (
            <span style={{ display: 'inline-flex', gap: 6, alignItems: 'center', fontSize: 12.5, color: slate }}>
              {isSelf ? 'This signs you out too.' : `Sign ${memberName} out everywhere?`}
              <button onClick={() => end('all')} disabled={busy} style={dangerBtn}>{busy ? 'Ending…' : 'Yes, end all'}</button>
              <button onClick={() => setConfirming(null)} disabled={busy} style={{ ...topBtn(false, isDark), padding: '5px 10px', fontSize: 12.5 }}>Cancel</button>
            </span>
          ) : (
            <button onClick={() => setConfirming('all')} style={dangerBtn}>End all sessions</button>
          )
        )}
      </div>
      <div style={{ fontSize: 12.5, color: muted, marginBottom: 14 }}>
        Sign-ins used within this member's auto sign-out window ({idleWindow}). Ending a session signs that browser
        out straight away. Updates every 30 seconds.
      </div>
      {sessions.length === 0 ? (
        <div style={{ fontSize: 14, color: slate, padding: '18px 0' }}>No active sessions. This member isn't signed in anywhere right now.</div>
      ) : (
        <div style={{ border: `1px solid ${line}`, borderRadius: 10, overflow: 'hidden' }}>
          {sessions.map((sess, i) => {
            const device = [sess.browser, sess.os].filter(v => v && v !== 'Unknown').join(' on ') || 'Unknown device';
            return (
              <div key={sess.id} style={{ padding: '14px 16px', borderTop: i ? `1px solid ${line}` : 'none' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: green, flexShrink: 0 }} />
                    <span style={{ fontSize: 14.5, fontWeight: 600, color: ink }}>{device}</span>
                    {sess.is_current && (
                      <span style={{ fontSize: 11, fontWeight: 700, color: green, background: `${green}1f`, borderRadius: 99, padding: '2px 8px' }}>This device</span>
                    )}
                  </div>
                  <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
                    <span style={{ fontSize: 12.5, color: muted, whiteSpace: 'nowrap' }} title={fmtDateTime(sess.last_active_at)}>
                      Active {fmtRelative(sess.last_active_at)}
                    </span>
                    {confirming === sess.id ? (
                      <>
                        <button onClick={() => end(sess.id)} disabled={busy} style={dangerBtn}>{busy ? 'Ending…' : sess.is_current ? 'Yes, sign me out' : 'Yes, end it'}</button>
                        <button onClick={() => setConfirming(null)} disabled={busy} style={{ ...topBtn(false, isDark), padding: '5px 10px', fontSize: 12.5 }}>Cancel</button>
                      </>
                    ) : (
                      <button onClick={() => setConfirming(sess.id)} style={dangerBtn}>End session</button>
                    )}
                  </span>
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: '110px 1fr', gap: '6px 12px', marginTop: 10, fontSize: 13 }}>
                  <span style={{ color: slate }}>IP address</span>
                  <span style={{ color: ink, fontFamily: "'JetBrains Mono', ui-monospace, monospace" }}>{sess.ip_address || 'Not recorded'}</span>
                  <span style={{ color: slate }}>Signed in</span>
                  <span style={{ color: ink }}>{sess.signed_in_at ? fmtDateTime(sess.signed_in_at) : 'Not recorded'}</span>
                  <span style={{ color: slate }}>Expires</span>
                  <span style={{ color: ink }}>{sess.expires_at ? fmtDateTime(sess.expires_at) : 'Not recorded'}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </section>
  );
}

/* ── Invite drawer: one or many people, one role ─────────────────── */
interface Invitee { key: number; name: string; email: string }

/* ─── Confirmation before vendors change owner ───────────────────────── */

function ConfirmMoveDialog({ isDark, fromName, vendors, toName, busy, onCancel, onConfirm }: {
  isDark: boolean; fromName: string; vendors: OwnedVendor[]; toName: string | null; busy: boolean; onCancel: () => void; onConfirm: () => void;
}) {
  const ink = isDark ? '#e5e7eb' : T.ink, slate = isDark ? '#94a3b8' : T.slate, muted = isDark ? '#64748b' : T.muted;
  const line = isDark ? '#1f1f1f' : T.bdr, surface = isDark ? '#0d0d0d' : T.surface, surface2 = isDark ? '#141414' : T.surface2;
  const n = vendors.length;
  const names = vendors.slice(0, 5);

  // Escape cancels the confirmation only (the member drawer's own Escape listener is a bubble-phase one on window).
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !busy) { e.stopImmediatePropagation(); onCancel(); } };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [onCancel, busy]);

  return createPortal(
    <div onMouseDown={e => { if (e.target === e.currentTarget && !busy) onCancel(); }}
      style={{ position: 'fixed', inset: 0, zIndex: 1500, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, fontFamily: sans }}>
      <div role="alertdialog" aria-label="Confirm ownership change" style={{ width: 440, maxWidth: '100%', background: surface, border: `1px solid ${line}`, borderRadius: 12, padding: 20 }}>
        <div style={{ fontSize: 16, fontWeight: 700, color: ink }}>
          {toName ? `Move ${n} vendor${n === 1 ? '' : 's'} to ${toName}?` : `Leave ${n} vendor${n === 1 ? '' : 's'} unassigned?`}
        </div>
        <div style={{ fontSize: 13.5, color: slate, marginTop: 8, lineHeight: 1.55 }}>
          {toName
            ? <>{toName} becomes the owner instead of {fromName}, and will be the one notified and accountable for {n === 1 ? 'it' : 'them'}.</>
            : <>{fromName} will no longer own {n === 1 ? 'it' : 'them'}, and nobody will until you assign a new owner.</>}
        </div>
        <div style={{ marginTop: 14, border: `1px solid ${line}`, borderRadius: 8, background: surface2, padding: '8px 12px' }}>
          {names.map(v => (
            <div key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '4px 0', fontSize: 13.5, color: ink }}>
              <img src={`https://www.google.com/s2/favicons?domain=${v.domain}&sz=64`} alt="" style={{ width: 16, height: 16, objectFit: 'contain' }} />
              <span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{v.name}</span>
            </div>
          ))}
          {n > names.length && <div style={{ fontSize: 12.5, color: muted, paddingTop: 4 }}>and {n - names.length} more</div>}
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 18 }}>
          <button autoFocus onClick={onCancel} disabled={busy} style={{ ...topBtn(false, isDark), padding: '8px 14px', fontSize: 13 }}>Cancel</button>
          <button onClick={onConfirm} disabled={busy} style={{ ...topBtn(true, isDark), padding: '8px 14px', fontSize: 13 }}>
            {busy ? 'Moving…' : toName ? `Move ${n}` : `Unassign ${n}`}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}

/* ─── All vendors a member owns (popup from the member drawer) ─────── */

type OwnedSort = 'risk' | 'name' | 'score_desc';

function OwnedVendorsModal({ member, vendors, teammates, isDark, onClose, onOpenVendor }: {
  member: User; vendors: OwnedVendor[]; teammates: User[]; isDark: boolean; onClose: () => void; onOpenVendor: (id: string) => void;
}) {
  const { enqueueSnackbar } = useSnackbar();
  const ink = isDark ? '#e5e7eb' : T.ink, slate = isDark ? '#94a3b8' : T.slate, muted = isDark ? '#64748b' : T.muted;
  const line = isDark ? '#1f1f1f' : T.bdr, surface = isDark ? '#0d0d0d' : T.surface, surface2 = isDark ? '#141414' : T.surface2;

  const [search, setSearch] = useState('');
  const [bucket, setBucket] = useState<RiskBucket | ''>('');
  const [sort, setSort] = useState<OwnedSort>('risk');
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState<Set<string>>(new Set());
  const [moveTo, setMoveTo] = useState('');
  const [confirming, setConfirming] = useState(false);
  const confirmingRef = useRef(false);
  confirmingRef.current = confirming;

  const moveMutation = useMutation({
    mutationFn: async ({ ids, to }: { ids: string[]; to: string }) =>
      (await api.post('/v1/vendors/bulk-owner', { vendor_ids: ids, owner_user_id: to || null })).data as { updated: number },
    meta: { invalidates: USER_DATA },
  });

  // Escape closes this popup only, not the member drawer underneath (its listener is on window too); with the
  // confirmation open it only cancels the confirmation.
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key !== 'Escape') return;
      e.stopImmediatePropagation();
      if (confirmingRef.current) setConfirming(false); else onClose();
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, [onClose]);

  const counts = RISK_BUCKETS.map(b => [b, vendors.filter(v => riskBucket(v.score) === b).length] as const).filter(([, n]) => n > 0);
  const q = search.trim().toLowerCase();
  const matching = vendors
    .filter(v => (!bucket || riskBucket(v.score) === bucket) && (!q || v.name.toLowerCase().includes(q) || (v.domain || '').toLowerCase().includes(q)))
    .sort((a, b) => sort === 'name' ? a.name.localeCompare(b.name)
      : sort === 'score_desc' ? (b.score ?? -1) - (a.score ?? -1) || a.name.localeCompare(b.name)
      : (a.score ?? 101) - (b.score ?? 101) || a.name.localeCompare(b.name));
  const pages = Math.max(1, Math.ceil(matching.length / OWNED_PAGE_SIZE));
  const current = Math.min(page, pages);
  const rows = matching.slice((current - 1) * OWNED_PAGE_SIZE, current * OWNED_PAGE_SIZE);
  const allMatching = matching.length > 0 && matching.every(v => selected.has(v.id));
  const toggle = (id: string) => setSelected(prev => { const next = new Set(prev); if (next.has(id)) next.delete(id); else next.add(id); return next; });

  const move = async () => {
    const ids = Array.from(selected);
    try {
      const data = await moveMutation.mutateAsync({ ids, to: moveTo });
      const to = teammates.find(t => t.id === moveTo);
      enqueueSnackbar(to ? `${data.updated} vendor(s) moved to ${to.name}` : `${data.updated} vendor(s) unassigned`, { variant: 'success' });
      setSelected(new Set());
      setMoveTo('');
    } catch (e) {
      enqueueSnackbar(apiError(e, 'Could not move the vendors'), { variant: 'error' });
    } finally {
      setConfirming(false);
    }
  };

  const control: React.CSSProperties = {
    padding: '8px 10px', fontSize: 13.5, fontFamily: sans, color: ink, background: surface, border: `1px solid ${line}`, borderRadius: 8, outline: 'none',
  };
  const th: React.CSSProperties = {
    textAlign: 'left', fontSize: 11, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: slate,
    padding: '9px 14px', background: surface2, borderBottom: `1px solid ${line}`, position: 'sticky', top: 0, zIndex: 1,
  };
  const td: React.CSSProperties = { padding: '10px 14px', borderBottom: `1px solid ${line}`, fontSize: 13.5, color: ink, verticalAlign: 'middle' };

  return createPortal(
    <div onMouseDown={e => { if (e.target === e.currentTarget && !confirming) onClose(); }}
      style={{ position: 'fixed', inset: 0, zIndex: 1400, background: 'rgba(15,23,42,.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, fontFamily: sans }}>
      {confirming && (
        <ConfirmMoveDialog isDark={isDark} fromName={member.name} vendors={vendors.filter(v => selected.has(v.id))}
          toName={teammates.find(t => t.id === moveTo)?.name ?? null} busy={moveMutation.isPending}
          onCancel={() => setConfirming(false)} onConfirm={move} />
      )}
      <div role="dialog" aria-label={`Vendors owned by ${member.name}`} style={{ width: 860, maxWidth: '100%', height: 'min(720px, 90vh)', display: 'flex', flexDirection: 'column',
        background: surface, border: `1px solid ${line}`, borderRadius: 12, overflow: 'hidden' }}>
        <div style={{ padding: '16px 20px', borderBottom: `1px solid ${line}`, display: 'flex', alignItems: 'flex-start', gap: 12 }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ fontSize: 17, fontWeight: 700, color: ink }}>Vendors owned by {member.name}</div>
            <div style={{ display: 'flex', gap: 14, flexWrap: 'wrap', marginTop: 6, fontSize: 12.5, color: slate }}>
              <span><strong style={{ color: ink }}>{vendors.length}</strong> vendors</span>
              {counts.map(([b, n]) => (
                <span key={b} style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
                  <span style={{ width: 7, height: 7, borderRadius: '50%', background: BUCKET_COLOR[b] }} />
                  <strong style={{ color: ink }}>{n}</strong> {b === 'Not scanned' ? 'not scanned' : b.toLowerCase()}
                </span>
              ))}
            </div>
          </div>
          <button aria-label="Close" onClick={onClose} style={{ ...control, padding: '6px 9px', cursor: 'pointer', display: 'flex' }}><Icon d={I.close} /></button>
        </div>

        <div style={{ display: 'flex', gap: 8, padding: '12px 20px', borderBottom: `1px solid ${line}`, flexWrap: 'wrap', alignItems: 'center' }}>
          <input autoFocus value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} placeholder="Search by name or domain"
            aria-label="Search vendors" style={{ ...control, flex: '1 1 220px', minWidth: 0 }} />
          <select aria-label="Risk" value={bucket} onChange={e => { setBucket(e.target.value as RiskBucket | ''); setPage(1); }} style={{ ...control, cursor: 'pointer' }}>
            <option value="">All risk levels</option>
            {counts.map(([b, n]) => <option key={b} value={b}>{b} ({n})</option>)}
          </select>
          <select aria-label="Sort" value={sort} onChange={e => setSort(e.target.value as OwnedSort)} style={{ ...control, cursor: 'pointer' }}>
            <option value="risk">Riskiest first</option>
            <option value="score_desc">Highest score first</option>
            <option value="name">Name A–Z</option>
          </select>
        </div>

        <div style={{ flex: 1, overflowY: 'auto' }}>
          {matching.length === 0 ? (
            <div style={{ padding: 40, textAlign: 'center', fontSize: 14, color: slate }}>No vendor matches.</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr>
                  <th style={{ ...th, width: 36 }}>
                    <input type="checkbox" aria-label="Select all matching" checked={allMatching}
                      onChange={() => setSelected(prev => { const next = new Set(prev); matching.forEach(v => (allMatching ? next.delete(v.id) : next.add(v.id))); return next; })} />
                  </th>
                  <th style={th}>Vendor</th>
                  <th style={th}>Risk</th>
                  <th style={{ ...th, textAlign: 'right' }}>Score</th>
                  <th style={{ ...th, width: 30 }} />
                </tr>
              </thead>
              <tbody>
                {rows.map(v => {
                  const b = riskBucket(v.score);
                  const on = selected.has(v.id);
                  return (
                    <tr key={v.id} onClick={() => onOpenVendor(v.id)} style={{ cursor: 'pointer', background: on ? (isDark ? '#0a1628' : T.blueBg) : 'transparent' }}
                      onMouseEnter={e => { if (!on) e.currentTarget.style.background = surface2; }}
                      onMouseLeave={e => { e.currentTarget.style.background = on ? (isDark ? '#0a1628' : T.blueBg) : 'transparent'; }}>
                      <td style={td} onClick={e => e.stopPropagation()}>
                        <input type="checkbox" aria-label={`Select ${v.name}`} checked={on} onChange={() => toggle(v.id)} />
                      </td>
                      <td style={td}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
                          <img src={`https://www.google.com/s2/favicons?domain=${v.domain}&sz=64`} alt="" style={{ width: 22, height: 22, objectFit: 'contain', flexShrink: 0 }} />
                          <div style={{ minWidth: 0 }}>
                            <div style={{ fontWeight: 600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{v.name}</div>
                            <div style={{ fontSize: 12.5, color: muted }}>{v.domain}</div>
                          </div>
                        </div>
                      </td>
                      <td style={td}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6, fontSize: 12.5, fontWeight: 600, color: BUCKET_COLOR[b] }}>
                          <span style={{ width: 7, height: 7, borderRadius: '50%', background: BUCKET_COLOR[b] }} />{b}
                        </span>
                      </td>
                      <td style={{ ...td, textAlign: 'right', fontWeight: 700 }}>
                        {v.score != null ? <>{v.score}<span style={{ color: muted, fontWeight: 500 }}>/100</span></> : <span style={{ color: muted, fontWeight: 400 }}>—</span>}
                      </td>
                      <td style={{ ...td, color: muted }}><Icon d={I.chevron} /></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>

        <div style={{ padding: '12px 20px', borderTop: `1px solid ${line}`, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
          {selected.size > 0 ? (
            <>
              <span style={{ fontSize: 13.5, color: ink, fontWeight: 600 }}>{selected.size} selected</span>
              <button onClick={() => setSelected(new Set())} style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontFamily: sans, fontSize: 13, color: muted }}>Clear</button>
              <select aria-label="Move selected to" value={moveTo} onChange={e => setMoveTo(e.target.value)} style={{ ...control, marginLeft: 'auto', cursor: 'pointer', minWidth: 200 }}>
                <option value="">Leave unassigned</option>
                {teammates.map(t => <option key={t.id} value={t.id}>{t.name} ({roleMeta(t.role).label})</option>)}
              </select>
              <button onClick={() => setConfirming(true)} disabled={moveMutation.isPending} style={{ ...topBtn(true, isDark), padding: '8px 14px', fontSize: 13 }}>
                <Icon d={I.swap} /> {moveMutation.isPending ? 'Moving…' : `Move ${selected.size}`}
              </button>
            </>
          ) : (
            <span style={{ fontSize: 12.5, color: muted }}>Select vendors to move them to another owner.</span>
          )}
          {pages > 1 && (
            <span style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: selected.size ? 0 : 'auto', fontSize: 12.5, color: slate }}>
              {(current - 1) * OWNED_PAGE_SIZE + 1}–{Math.min(current * OWNED_PAGE_SIZE, matching.length)} of {matching.length}
              <button disabled={current === 1} onClick={() => setPage(current - 1)} style={{ ...control, padding: '5px 10px', cursor: 'pointer', opacity: current === 1 ? 0.5 : 1 }}>‹</button>
              <button disabled={current === pages} onClick={() => setPage(current + 1)} style={{ ...control, padding: '5px 10px', cursor: 'pointer', opacity: current === pages ? 0.5 : 1 }}>›</button>
            </span>
          )}
          {pages <= 1 && !selected.size && <span style={{ marginLeft: 'auto', fontSize: 12.5, color: slate }}>{matching.length} of {vendors.length}</span>}
        </div>
      </div>
    </div>,
    document.body,
  );
}

function InviteDrawer({ isDark, seatsLeft, existingEmails, onClose, onDone }: {
  isDark: boolean; seatsLeft: number; existingEmails: string[]; onClose: () => void; onDone: (created: number) => void;
}) {
  const ink = isDark ? '#e5e7eb' : T.ink, slate = isDark ? '#94a3b8' : T.slate, muted = isDark ? '#64748b' : T.muted;
  const line = isDark ? '#1f1f1f' : T.bdr, surface = isDark ? '#0d0d0d' : T.surface, surface2 = isDark ? '#141414' : T.surface2;
  const accent = isDark ? '#3B82F6' : T.blue;

  const [people, setPeople] = useState<Invitee[]>([{ key: 0, name: '', email: '' }]);
  const nextKey = useRef(1);
  const [role, setRole] = useState('risk_analyst');
  const [sendInvite, setSendInvite] = useState(true);
  const [jobTitle, setJobTitle] = useState('');
  const [department, setDepartment] = useState('');
  const [location, setLocation] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const created = useRef(0);
  const queryClient = useQueryClient();

  const emailOk = (e: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim());
  const filled = people.filter(p => p.email.trim() || p.name.trim());
  const emails = filled.map(p => p.email.trim().toLowerCase());
  const problems: Record<number, string> = {};
  filled.forEach((p, i) => {
    const e = p.email.trim().toLowerCase();
    if (!p.name.trim()) problems[p.key] = 'Add a name';
    else if (!emailOk(e)) problems[p.key] = 'Enter a valid email';
    else if (existingEmails.includes(e)) problems[p.key] = 'Already on your team';
    else if (emails.indexOf(e) !== i) problems[p.key] = 'Listed twice';
  });
  const overSeats = Number.isFinite(seatsLeft) && filled.length > seatsLeft;
  const ready = filled.length > 0 && !Object.keys(problems).length && !overSeats;
  const single = people.length === 1;

  const update = (key: number, patch: Partial<Invitee>) => setPeople(p => p.map(x => x.key === key ? { ...x, ...patch } : x));
  const add = () => setPeople(p => [...p, { key: nextKey.current++, name: '', email: '' }]);
  const remove = (key: number) => setPeople(p => (p.length === 1 ? [{ key: nextKey.current++, name: '', email: '' }] : p.filter(x => x.key !== key)));

  // Paste "Name <email>" / "email" lines straight into the first email box to fill several rows at once.
  const handlePaste = (key: number, text: string) => {
    const lines = text.split(/[\n,;]+/).map(l => l.trim()).filter(Boolean);
    if (lines.length < 2) return false;
    const parsed = lines.map(l => {
      const m = /^(.*?)<\s*([^>]+)\s*>$/.exec(l);
      if (m) return { name: m[1].trim().replace(/^"|"$/g, ''), email: m[2].trim() };
      const email = l.replace(/^mailto:/i, '');
      return { name: email.split('@')[0].replace(/[._-]+/g, ' ').replace(/\b\w/g, ch => ch.toUpperCase()), email };
    });
    setPeople(p => {
      const rest = p.filter(x => x.key !== key && (x.email || x.name));
      return [...rest, ...parsed.map(x => ({ key: nextKey.current++, ...x }))];
    });
    return true;
  };

  const submit = async () => {
    setSubmitting(true);
    setError('');
    const failed: string[] = [];
    const done: number[] = [];
    for (const p of filled) {
      const data: CreateUserData = {
        name: p.name.trim(), email: p.email.trim(), role, send_invite: sendInvite,
        job_title: single ? jobTitle : '', department: single ? department : '', location: single ? location : '', phone_number: '',
        max_active_sessions: 3, session_timeout_hours: 8, receive_notifications: true, api_access: role === 'admin',
      };
      try {
        await userApi.createUser(data);
        created.current += 1;
        done.push(p.key);
      } catch (e) {
        failed.push(`${p.email.trim()}: ${apiError(e, 'failed')}`);
      }
    }
    setSubmitting(false);
    // One refresh for the whole batch rather than one per invitee.
    if (done.length) queryClient.invalidateQueries({ queryKey: ['users'] });
    if (!failed.length) { onDone(created.current); return; }
    setPeople(prev => prev.filter(x => !done.includes(x.key)));
    setError(`${done.length ? `${done.length} invited. ` : ''}These could not be added and are still listed: ${failed.join('; ')}`);
  };

  const input: React.CSSProperties = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', fontSize: 14, fontFamily: sans, color: ink, background: surface, border: `1px solid ${line}`, borderRadius: 8, outline: 'none' };
  const sectionLabel: React.CSSProperties = { fontSize: 11.5, fontWeight: 700, letterSpacing: '.06em', textTransform: 'uppercase', color: slate, marginBottom: 12 };

  return (
    <DrawerShell isDark={isDark} width={720} onClose={() => { if (!submitting) (created.current ? onDone(created.current) : onClose()); }}>
      <div style={{ padding: '22px 26px 18px', borderBottom: `1px solid ${line}`, display: 'flex', justifyContent: 'space-between', gap: 12 }}>
        <div>
          <div style={{ fontSize: 20, fontWeight: 700, color: ink }}>Invite members</div>
          <div style={{ fontSize: 14, color: slate, marginTop: 3 }}>
            Add one person or several -- paste a list of emails to fill rows at once.
            {Number.isFinite(seatsLeft) && <> <strong style={{ color: overSeats ? '#DC2626' : ink }}>{seatsLeft} seat{seatsLeft === 1 ? '' : 's'} left.</strong></>}
          </div>
        </div>
        <button onClick={() => (created.current ? onDone(created.current) : onClose())} aria-label="Close" style={{ background: surface2, border: `1px solid ${line}`, color: slate, cursor: 'pointer', width: 32, height: 32, borderRadius: 8, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <Icon d={I.close} />
        </button>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', padding: '22px 26px', display: 'flex', flexDirection: 'column', gap: 26 }}>
        <section>
          <div style={sectionLabel}>People ({filled.length})</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {people.map((p, i) => (
              <div key={p.key}>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.3fr 40px', gap: 8 }}>
                  <input style={input} placeholder="Full name" value={p.name} onChange={e => update(p.key, { name: e.target.value })} autoFocus={i === 0} />
                  <input style={{ ...input, borderColor: problems[p.key] && p.email ? '#DC2626' : line }} placeholder="name@company.com" value={p.email}
                    onChange={e => update(p.key, { email: e.target.value })}
                    onPaste={e => { if (handlePaste(p.key, e.clipboardData.getData('text'))) e.preventDefault(); }} />
                  <button onClick={() => remove(p.key)} aria-label="Remove" style={{ width: 40, height: 40, borderRadius: 8, border: `1px solid ${line}`, background: surface, color: slate, cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Icon d={I.close} />
                  </button>
                </div>
                {problems[p.key] && (p.email || p.name) && <div style={{ fontSize: 12.5, color: '#DC2626', marginTop: 4 }}>{problems[p.key]}</div>}
              </div>
            ))}
          </div>
          <button onClick={add} style={{ marginTop: 10, background: 'none', border: 'none', color: accent, fontSize: 13.5, fontWeight: 600, cursor: 'pointer', fontFamily: sans, padding: 0 }}>+ Add another person</button>
          {overSeats && <div style={{ fontSize: 13, color: '#DC2626', marginTop: 8 }}>You're inviting {filled.length} people but only {seatsLeft} seat{seatsLeft === 1 ? ' is' : 's are'} free.</div>}
        </section>

        <section>
          <div style={sectionLabel}>Role{people.length > 1 ? ' for everyone above' : ''}</div>
          <RoleCards value={role} onChange={setRole} isDark={isDark} />
          <div style={{ marginTop: 14, padding: '14px 16px', borderRadius: 10, background: surface2, border: `1px solid ${line}` }}>
            <div style={{ fontSize: 13, fontWeight: 700, color: ink, marginBottom: 10 }}>A {roleMeta(role).label} can</div>
            <PermissionList role={role} isDark={isDark} />
          </div>
        </section>

        {single && (
          <section>
            <div style={sectionLabel}>Details <span style={{ textTransform: 'none', letterSpacing: 0, fontWeight: 500, color: muted }}>(optional)</span></div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
              <input style={input} placeholder="Job title" value={jobTitle} onChange={e => setJobTitle(e.target.value)} />
              <select style={input} value={department} onChange={e => setDepartment(e.target.value)}>
                <option value="">Department</option>{DEPARTMENTS.map(d => <option key={d}>{d}</option>)}
              </select>
              <select style={input} value={location} onChange={e => setLocation(e.target.value)}>
                <option value="">Location</option>{LOCATIONS.map(l => <option key={l}>{l}</option>)}
              </select>
            </div>
          </section>
        )}

        <section role="button" onClick={() => setSendInvite(v => !v)} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, padding: '14px 16px', borderRadius: 10, border: `1px solid ${line}`, cursor: 'pointer' }}>
          <div>
            <div style={{ fontSize: 14, fontWeight: 600, color: ink }}>Email an invitation now</div>
            <div style={{ fontSize: 12.5, color: slate, marginTop: 2 }}>They get a sign-in link and set their own password on first login.</div>
          </div>
          <span style={{ width: 36, height: 20, borderRadius: 99, background: sendInvite ? accent : (isDark ? '#333' : T.faint), position: 'relative', flexShrink: 0 }}>
            <span style={{ position: 'absolute', top: 2, left: sendInvite ? 18 : 2, width: 16, height: 16, borderRadius: 99, background: '#fff', transition: 'left .15s' }} />
          </span>
        </section>

        {error && <div style={{ fontSize: 13.5, color: '#DC2626', lineHeight: 1.5 }}>{error}</div>}
      </div>

      <div style={{ padding: '14px 26px', borderTop: `1px solid ${line}`, background: surface2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 }}>
        <span style={{ fontSize: 13, color: slate }}>{filled.length ? `${filled.length} ${filled.length === 1 ? 'person' : 'people'} as ${roleMeta(role).label}` : 'Add at least one person'}</span>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => (created.current ? onDone(created.current) : onClose())} disabled={submitting} style={topBtn(false, isDark)}>Cancel</button>
          <button onClick={submit} disabled={!ready || submitting} style={{ ...topBtn(true, isDark), opacity: ready && !submitting ? 1 : 0.5, cursor: ready ? 'pointer' : 'not-allowed' }}>
            <Icon d={I.send} /> {submitting ? 'Inviting…' : filled.length > 1 ? `Invite ${filled.length} people` : 'Send invite'}
          </button>
        </div>
      </div>
    </DrawerShell>
  );
}

/* ── Deactivate / delete confirmation, with vendor hand-over ─────── */
function ConfirmAction({ kind, member, ownedVendors, teammates, currentUserId, isDark, onClose, onDone }: {
  kind: 'deactivate' | 'delete'; member: User; ownedVendors: number; teammates: User[]; currentUserId?: string; isDark: boolean;
  onClose: () => void; onDone: (message: string) => void;
}) {
  const ink = isDark ? '#e5e7eb' : T.ink, slate = isDark ? '#94a3b8' : T.slate;
  const line = isDark ? '#1f1f1f' : T.bdr, surface = isDark ? '#0d0d0d' : T.surface, surface2 = isDark ? '#141414' : T.surface2;
  const isDelete = kind === 'delete';
  const defaultTarget = teammates.some(t => t.id === currentUserId) ? (currentUserId as string) : '';
  // keep = leave ownership as it is (deactivate only); '' = unassigned; otherwise a member id
  const [handover, setHandover] = useState<string>(isDelete ? defaultTarget : 'keep');
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const queryClient = useQueryClient();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape' && !busy) onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose, busy]);

  const confirmWord = member.email.split('@')[0];
  const canConfirm = !isDelete || typed.trim().toLowerCase() === confirmWord.toLowerCase();

  const run = async () => {
    setBusy(true);
    setError('');
    try {
      if (ownedVendors > 0 && handover !== 'keep') {
        await api.post(`/v1/users/${member.id}/transfer-vendors`, { to_user_id: handover || null });
      }
      if (isDelete) await userApi.deleteUserPermanently(member.id);
      else await userApi.deactivateUser(member.id);
      onDone(isDelete ? `${member.name} was deleted` : `${member.name} was deactivated`);
    } catch (e) {
      setError(apiError(e, `Could not ${kind} this member`));
      setBusy(false);
    } finally {
      // Also after a failure: the vendor hand-over may already have gone through.
      USER_DATA.forEach(queryKey => queryClient.invalidateQueries({ queryKey }));
    }
  };

  const input: React.CSSProperties = { width: '100%', boxSizing: 'border-box', padding: '10px 12px', fontSize: 14, fontFamily: sans, color: ink, background: surface, border: `1px solid ${line}`, borderRadius: 8, outline: 'none' };

  return (
    <div onMouseDown={e => { if (e.target === e.currentTarget && !busy) onClose(); }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(15,23,42,.5)', zIndex: 1400, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 520, background: surface, border: `1px solid ${line}`, borderRadius: 14, overflow: 'hidden', fontFamily: sans, animation: 'tmPop .16s ease-out' }}>
        <div style={{ padding: '22px 24px 0', display: 'flex', gap: 14 }}>
          <span style={{ width: 42, height: 42, borderRadius: 12, flexShrink: 0, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', color: '#DC2626', background: isDark ? '#2a0f0f' : T.redBg }}>
            <Icon d={isDelete ? I.trash : I.block} size={20} />
          </span>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: ink }}>{isDelete ? 'Delete' : 'Deactivate'} {member.name}?</div>
            <div style={{ fontSize: 14, color: slate, marginTop: 6, lineHeight: 1.55 }}>
              {isDelete
                ? 'Their account is removed for good and they are signed out everywhere. Their audit history stays, under their name. This cannot be undone.'
                : "They are signed out right away and can't sign in again until reactivated. Nothing they did is removed."}
            </div>
          </div>
        </div>

        <div style={{ padding: '18px 24px 22px', display: 'flex', flexDirection: 'column', gap: 16 }}>
          {ownedVendors > 0 && (
            <div style={{ padding: '14px 16px', borderRadius: 10, background: surface2, border: `1px solid ${line}` }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: ink, marginBottom: 8 }}>
                {member.name} owns {ownedVendors} vendor{ownedVendors === 1 ? '' : 's'}. Who should own {ownedVendors === 1 ? 'it' : 'them'} now?
              </div>
              <select value={handover} onChange={e => setHandover(e.target.value)} style={input}>
                {!isDelete && <option value="keep">Keep {member.name} as owner</option>}
                {teammates.map(t => <option key={t.id} value={t.id}>{t.name}{t.id === currentUserId ? ' (you)' : ''} · {roleMeta(t.role).label}</option>)}
                <option value="">Nobody -- leave unassigned</option>
              </select>
            </div>
          )}
          {isDelete && (
            <div>
              <div style={{ fontSize: 13.5, color: slate, marginBottom: 6 }}>Type <strong style={{ color: ink }}>{confirmWord}</strong> to confirm</div>
              <input value={typed} onChange={e => setTyped(e.target.value)} style={input} autoFocus />
            </div>
          )}
          {error && <div style={{ fontSize: 13.5, color: '#DC2626' }}>{error}</div>}
        </div>

        <div style={{ padding: '14px 24px', borderTop: `1px solid ${line}`, background: surface2, display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose} disabled={busy} style={topBtn(false, isDark)}>Cancel</button>
          <button onClick={run} disabled={busy || !canConfirm} style={{ ...topBtn(true, isDark), background: '#DC2626', borderColor: '#DC2626', color: '#fff', opacity: busy || !canConfirm ? 0.55 : 1, cursor: canConfirm ? 'pointer' : 'not-allowed' }}>
            {busy ? (isDelete ? 'Deleting…' : 'Deactivating…') : isDelete ? 'Delete permanently' : 'Deactivate'}
          </button>
        </div>
      </div>
    </div>
  );
}
